/* eslint-disable react/no-direct-mutation-state */
import React, { Component } from "react";
import { Row, Col, Icon, message, Spin, notification } from "antd";
import axios from "axios";
import moment from "moment";
import './parts/steps.css';
import WizardSteps from "./parts/steps";
import StepCall from "./parts/step-call";
import Step1 from "./parts/step1_updated";
import Step2 from "./parts/step2_updated";
import Step2_1 from "./parts/step2_1_updated";
import Step3 from "./parts/step3_updated";
import Step3_1 from "./parts/step3_1_updated";
import Step3_2 from "./parts/step3_2_updated";
import Step3_3 from "./parts/step3_3_updated";
import Step3_4 from "./parts/step3_4_updated";
import Step4 from "./parts/step4_updated";
import Step4_1 from "./parts/step4_1_updated";
import Step5 from "./parts/step5_updated";
import Step5_1 from "./parts/step5_1_updated";
import Step6 from "./parts/step6_updated";
// import Step7 from "./parts/step7";
// import Step7_1 from "./parts/step7_1";
import Validation, { validationCheck } from "./parts/validation";
import Sidebar from "./parts/sidebar";
import F from "../../Functions";
import ChangeOwnershipModal from "./parts/change-ownership-modal";
import DataHandler from "../../utils/DataHandler";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
import ScrollToTop from "../../ScrollToTop";
import { BFILE_HAS_BEEN_UPDATED, EMAIL_ADDRESS_IS_INVALID, FOLLOW_UP_CALL, NEW_BFILE, NOTE_PREFIX, PLEASE_FILL_ALL_REQUIRED_FIELD, PROFILE_HAS_BEEN_UPDATED_AND_SAVED_FOR_LATER, PROSPECT, RE_QUOTE, RENEWAL, REVIEW, SEND_BFILE, THANKYOU_REFERRALS, WIZARD } from "../../utils/Constants";
import { error } from "jquery";
import ExternalBFileThanks from "./parts/ExternalBFileThanks";
import { EXTERNAL_RAC_EXISTING_CUSTOMER_CHECK, EXTERNAL_RAC_UPLOAD_HISTORY, UPDATE_RAC_DATE } from "../../utils/Api_enums";

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const calculateUmbrellaLimitFromRac = (racCalculator) => {
  const racValue = Number(String(racCalculator || 0).replace(/[$,]/g, ""));

  if (!Number.isFinite(racValue) || racValue < 500000) return "";

  // Matches the thresholds used in step6_updated.js:
  // $500k-$1.249m => $1m, then another $1m for each $1m RAC band,
  // capped at the $10m recommendation.
  const recommendedMillions = Math.floor((racValue - 250000) / 1000000) + 1;
  return Math.min(recommendedMillions, 10) * 1000000;
};

class Wizard extends Component {
  state = {
    loading: false,
    user: this.props.auth.user,
    last_index: 1,
    change_ownership_modal: false,
    is_calculator_only: false,
    wizard: {
      error: { currentIndex: {} },
      ready: false,
      stepIndex: 1,
      isSentBfile: false,
      onboarding_user: null,
      id: "",
      notes: "",
      status: "New B File",
      status_spouse: "New B File",
      acknowledge_by: null,
      acknowledge: null,
      action: "",
      address: "",
      address_cont: "",
      agency_id: null,
      agency_info: { name: null, address: null, email: null, phone: null },
      archive: 0,
      asset_401k_accounts_toggle: null,
      asset_401k_accounts_toggle_spouse: null,
      asset_401k_accounts: "[]",
      asset_401k_accounts_spouse: "[]",
      asset_401k_value: 0,
      asset_accounts: "[]",
      asset_accounts_spouse: "[]",
      asset_preservation_toggle: "",
      asset_preservation_value: "",
      asset_preservation_value_spouse: "",
      asset_total_value: "",
      asset_total_value_spouse: "",
      attempts: "0",
      auto_carrier: null,
      auto_expiration_date: null,
      auto_liability: null,
      auto_policy_not_sold_current_carrier: "",
      auto_policy_not_sold_current_liability_limit: "",
      auto_policy_not_sold_expiration_date: null,
      auto_policy_sold_bfile_limit: "",
      auto_policy_sold_current_liability_limit: "",
      auto_policy_sold_effective_date: null,
      auto_policy_sold_items_sold: "",
      auto_policy_sold_liability_limit_sold: "",
      auto_policy_sold_policy_premium: "",
      auto_policy_sold_term: "",
      auto_sold_toggle: "",
      birthday: "",
      business_loan_toggle: null,
      business_name: "",
      business_name_spouse: "",
      business_owner_toggle: "",
      business_owner_spouse_toggle: "",
      business_retirement_value: null,
      business_type: "",
      business_type_spouse: "",
      business_type_other: "",
      business_type_other_spouse: "",
      call_type: "",
      carrier: "",
      children: null,
      children_living_home_toggle: null,
      city: "",
      coverage_detail_toggle: null,
      cross_sell_opportunities_quoted: 0,
      cross_sell_opportunities_sold: 0,
      cross_sell_policies_uncovered: 0,
      deleted: 0,
      mortgage_review: null,
      mortgage_review_last: null,
      mortgage_purchase_home: null,
      had_mortgage_review: null,
      email: "",
      employed_anual_income: "",
      employed_anual_income_spouse: "",
      employed_length_spouse: null,
      employed_length: null,
      employed_retired_disabled: "",
      employed_retired_disabled_spouse: "",
      employed_toggle: "",
      employed_toggle_spouse: "",
      employees_count: null,
      employees_count_spouse: null,
      employer_name: "",
      employer_name_spouse: "",
      employer_retire_from_spouse: "",
      employer_years_spouse: "",
      employer_retire_from: "",
      employer_years: "",
      expiration_date: null,
      facebook: "",
      financial_calls_attempts: 0,
      first_name: "",
      home_bfile_liability: null,
      home_liability: null,
      home_liability_sold: null,
      home_market_value: "",
      home_mortgage: "",
      insurance_set: "",
      home_mortgage_protection_benefit: "",
      home_mortgage_protection_benefit_spouse: "",
      home_mortgage_protection_policy: "[]",
      home_mortgage_protection_policy_spouse: "[]",
      home_mortgage_protection_toggle: "",
      home_mortgage_protection_toggle_spouse: "",
      home_mortgage_toggle: "0",
      home_policy_not_sold_current_carrier: "",
      home_policy_not_sold_current_liability_limit: "",
      home_policy_not_sold_expiration_date: null,
      home_policy_premium: null,
      home_policy_sold_bfile_limit: "",
      home_policy_sold_effective_date: null,
      home_policy_sold_items_sold: "",
      home_policy_sold_liability_limit: "",
      home_policy_sold_liability_limit_sold: "",
      home_policy_sold_policy_premium: "",
      home_policy_sold_term: "",
      home_sold_toggle: "",
      home_toggle: "",
      insurance_score: "",
      internet_leads: 0,
      is_appointment_kept: 0,
      is_appointment_made: 0,
      is_appointment_sold: 0,
      is_lead: 0,
      is_onboarded: 0,
      is_renewal: 0,
      is_requote: 0,
      is_saved_for_later: 0,
      is_sent_to_financial: 0,
      language: null,
      last_name: "",
      liability_calculator_value: "0",
      life_opportunities: 0,
      life_opportunities_received: 0,
      life_opportunities_sold: 0,
      linkedin: "",
      need_attention: 0,
      no_policies_sold: 0,
      nosalearchive_expiration_date: null,
      not_interested: 0,
      parent_id: null,
      personal_property_toggle: null,
      personal_property_type: "[]",
      personal_property_value: "",
      phone: "",
      phone2: "",
      policy_umbrella_total: 0,
      primary_vehicles_num: null,
      primary_vehicles_toggle: "",
      profile_photo: "",
      quote_auto_toggle: "",
      quote_home_toggle: "",
      renewals: 0,
      retirement_dollars: 0,
      retirement_plan: "",
      retirement_plan_spouse: "",
      retirement_plan_value: "",
      retirement_plan_value_spouse: "",
      review: 0,
      rollover_dollars_created: 0.0,
      rollover_opportunities: 0,
      secondary_home_market_value: "",
      secondary_home_mortgage: "",
      secondary_home_mortgage_toggle: "",
      secondary_home_toggle: "",
      secondary_home_type: "[]",
      secondary_mortgage_protection_benefit: "",
      secondary_mortgage_protection_policy: "",
      secondary_mortgage_protection_toggle: "",
      secondary_vehicles: "[]",
      secondary_vehicles_toggle: "",
      secondary_vehicles_value: "",
      sp_500: 0,
      spouse_birthday: "",
      spouse_first_name: "",
      spouse_last_name: "",
      spouse_toggle: null,
      state: "",
      sub_type_of_call: "",
      sub_type_of_call_change: "",
      twitter: "",
      toggle: "person",
      type_of_call: "",
      type_of_call_change: "",
      type_of_call_old: "",
      umbrella_limit: "",
      umbrella_policy_quoted: 0,
      umbrella_policy_sold: 0,
      umbrella_policy_uncovered: 0,
      user_id: "",
      vip: 0,
      vonboard: 0,
      zipcode: "",
      dob_dd: "",
      dob_mm: "",
      dob_yyyy: "",
      dob_age: "",
      dob2_mm: "",
      dob2_yyyy: "",
      dob2_age: "",
      policies: [],
      financial_id: null,
      onboarding_id: null,
      onboarder_id: null,
      vo_sent_date: null,
      step_insurance_question: null,
      step_insurance_question_spouse: null,
      modal_customer_bfile_id: null,
      show_modal_customer_exist: false,
      modal_customer_ignore: false, // not using

      no_follow_up: null,

      isQuickFollowUpCallFromBFileAction: false,

      // Add Attributes for BMG-471 --> Add Zillow to “secondary home”
      zillow_address: null,
      zillow_estimated_value: null,
      secondary_zillow_address: null,
      secondary_zillow_estimated_value: null,

      // Add attribute for calculate coverage
      coverage: null,

      // Add attribute for life insurance 
      life_insurance_toggle_1: null,
      life_insurance_toggle_2: null,
      life_insurance_toggle_3: null,

      //for managing address update
      profile_address_updated: false,

      //To maintain the completed_history in single life cycle
      completed_count: 0,
      completed: false,
    },
    agency_owner_details: {}
  };


  isSavedForLater = (wizard) => {
    let localStorageWizard = localStorage.getItem('wizard');
    try {
      localStorageWizard = JSON.parse(localStorageWizard);
    } catch (e) {
      localStorageWizard = {};
    }
    let isSaved = false;
    if (window.location.hash.split("/").includes("wizard?new") && localStorageWizard) {
      isSaved = JSON.stringify(localStorageWizard) !== JSON.stringify(wizard);
      localStorage.setItem('isSavedForLater', isSaved);
    } else if (window.location.hash.split("/").includes("wizard") && window.location.hash.split("/").includes("step")) {
      isSaved = JSON.stringify(localStorageWizard) !== JSON.stringify(wizard);
      localStorage.setItem('isSavedForLater', isSaved);
    }
    else if (!localStorageWizard) {
      localStorage.setItem('isSavedForLater', false);
    }
  };




  getBFileData = (bfileId) => {
    const bfile_id = bfileId;
    const apiURL = this.props.isExternalBFile ? `/api/bfile_token/external_rac/${bfile_id}` :
      `/api/b_file/${bfile_id}${this.state.user.user_type === 'SUPER_ADMIN' && `?user_type=${this.props.history.location.state.user_type}` || ''}`;
    const { user } = this.state;
    this.setState({ loading: true });
    axios.get(apiURL).then((res) => {
      const data = res.data;
      const rac = F.bfile_rac(data);
      if (data.user && !data.user.carrier) data.user.carrier = this.state.wizard.carrier
      F.log("Rac financial 2 =>" + rac.financial);
      // data.stepIndex = 1;
      data.stepIndex =
        "bfileType" in window.localStorage &&
          window.localStorage.bfileType === "quick"
          ? 13
          : 1;
      data.expiration_date_old = data.expiration_date;
      data.type_of_call_old = data.type_of_call;

      // if (type_of_call_format(data.type_of_call) === 'followup') {
      //   data.sub_type_of_call = get_label_from_value(data.sub_type_of_call, 'value', data.type_of_call) ? Array.from(new Set(('Thank You / Referrals,' + get_label_from_value(data.sub_type_of_call, 'value', data.type_of_call)).split(","))).join(",") : 'Thank You / Referrals'
      // } else {
      //   data.type_of_call = 'FollowUp';
      //   data.sub_type_of_call = 'Thank You / Referrals'
      // }



      if (data.stepIndex === 13) {
        data.isQuickFollowUpCallFromBFileAction = true
        // data.type_of_call = "FollowUp"
        // data.sub_type_of_call = ""
      }


      data.rac_calculator = rac.rac;
      data.agency_info = {
        ...this.state.agency_info,
        active: data.agency.active,
        calculator_only: data.agency.calculator_only,
        review: data.agency.review,
        vonboard: data.agency.vonboard,
        is_lead: data.agency.is_lead,
        is_opportunity: data.agency.is_opportunity
      }

      data.rac_auto = rac.auto;
      data.rac_home = rac.home;
      data.rac_financial = rac.financial;
      data.rac_financial_spouse = rac.financial_spouse;
      data.rac_customary_items = rac.customary_items;
      data.rac_income = rac.income;
      data.rac_income_spouse = rac.income_spouse;
      data.ready = true;
      data.mortgage_review_last = data.mortgage_review;
      data.carrier = data && data.user && data.user.carrier;
      data.status = "Renewal"
      if (data.children === "") data.children = null;
      if (data.primary_vehicles_num === "")
        data.primary_vehicles_num = null;
      data.dob_mm = "";
      data.dob_dd = "";
      data.dob_yyyy = "";
      data.dob_age = "";
      data.dob2_mm = "";
      data.dob2_yyyy = "";
      data.dob2_age = "";
      data.acknowledge = null;
      if (data.birthday !== "" && data.birthday !== null) {
        const birthday = data.birthday.split("/");
        if (parseInt(birthday[0], 10) < 10) {
          data.dob_mm = "0" + parseInt(birthday[0], 10);
        } else {
          data.dob_mm = birthday[0] + "";
        }
        // data.dob_dd = birthday[1] + "";
        data.dob_yyyy = birthday[2] + "";
        data.dob_age = F.getAge(new Date(data.birthday));
      }

      if (data.spouse_birthday !== "" && data.spouse_birthday !== null) {
        const spouse_birthday = data.spouse_birthday.split("/");
        if (parseInt(spouse_birthday[0], 10) < 10) {
          data.dob2_mm = "0" + parseInt(spouse_birthday[0], 10);
        } else {
          data.dob2_mm = spouse_birthday[0] + "";
        }
        data.dob2_yyyy = spouse_birthday[2] + "";
        data.dob2_age = F.getAge(new Date(data.spouse_birthday));
      }
      if (
        data.auto_policy_sold_effective_date !== "" &&
        data.auto_policy_sold_effective_date !== null
      ) {
        data.auto_policy_sold_effective_date = moment(
          data.auto_policy_sold_effective_date
        );
      }
      if (
        data.auto_policy_not_sold_expiration_date !== "" &&
        data.auto_policy_not_sold_expiration_date !== null
      ) {
        data.auto_policy_not_sold_expiration_date = moment(
          data.auto_policy_not_sold_expiration_date
        );
      }
      if (
        data.home_policy_sold_effective_date !== "" &&
        data.home_policy_sold_effective_date !== null
      ) {
        data.home_policy_sold_effective_date = moment(
          data.home_policy_sold_effective_date
        );
      }
      if (
        data.home_policy_not_sold_expiration_date !== "" &&
        data.home_policy_not_sold_expiration_date !== null
      ) {
        data.home_policy_not_sold_expiration_date = moment(
          data.home_policy_not_sold_expiration_date
        );
      }
      const policies = [];
      if (data.policies.length > 0) {
        for (var i = 0; i < data.policies.length; i++) {
          if (data.policies[i].policy_sold === null) {
            data.policies[i].policy_sold = "";
          }
          policies.push({
            type: data.policies[i].policy_type,
            sold: data.policies[i].policy_sold + "",
            policy: ""
          });
        }
      }
      data.policies = policies;
      if (data.asset_401k_accounts === '["None"]') {
        data.asset_401k_accounts_toggle = 0;
      } else if (
        data.asset_401k_accounts !== "" &&
        data.asset_401k_accounts !== "[]" &&
        data.asset_401k_accounts !== null
      ) {
        data.asset_401k_accounts_toggle = 1;
      }

      if (data.asset_401k_accounts_spouse === '["None"]') {
        data.asset_401k_accounts_toggle_spouse = 0;
      } else if (
        data.asset_401k_accounts_spouse !== "" &&
        data.asset_401k_accounts_spouse !== "[]" &&
        data.asset_401k_accounts_spouse !== null
      ) {
        data.asset_401k_accounts_toggle_spouse = 1;
      }

      let change_ownership_modal = false;
      if (typeof this.props.match.params.action !== "undefined") {
        const action = this.props.match.params.action;
        if (action === "renewal") {
          data.stepIndex = 0;
          data.status = "Renewal";
          if (data.parent_id === null || data.parent_id === "") {
            data.parent_id = data.id;
          }
          data.id = "";
          data.archive = 0;
          if (data.user_id !== user.id) {
            change_ownership_modal = true;
          }
        }
      }
      data.step_insurance_question = data.step_insurance_question ? data.step_insurance_question : null;
      // check if user comes here from Quick "Follow-Up Call" B File Profile Action ( update wizard state )
      const state = this.props.location.state;
      const isQuickFollowUp = state != null && state.quickFollowUp;

      data.completed_count = 0;

      //new insurance logic default value for different sections for edit case
      if (data.home_mortgage_protection_toggle === "" || data.home_mortgage_protection_toggle === null) {
        data.life_insurance_toggle_1 = null;
        data.life_insurance_toggle_2 = null;
        data.life_insurance_toggle_3 = null;
      } else {
        switch (data.insurance_set) {
          case "primary_home":
            data.life_insurance_toggle_1 = data.home_mortgage_protection_toggle;
            data.life_insurance_toggle_2 = "0";
            data.life_insurance_toggle_3 = "0";
            break;
          case "secondary_home":
            data.life_insurance_toggle_1 = "0";
            data.life_insurance_toggle_2 = data.home_mortgage_protection_toggle;
            data.life_insurance_toggle_3 = "0";
            break;
          case "financial":
            data.life_insurance_toggle_1 = "0";
            data.life_insurance_toggle_2 = "0";
            data.life_insurance_toggle_3 = data.home_mortgage_protection_toggle;
            break;
          default:
            data.life_insurance_toggle_1 = null;
            data.life_insurance_toggle_2 = null;
            data.life_insurance_toggle_3 = null;
        }
      }


      // update wizard state
      data.isQuickFollowUpCallFromBFileAction = isQuickFollowUp;

      // if(data.isQuickFollowUpCallFromBFileAction){
      //   data.type_of_call = "FollowUp"
      //   data.sub_type_of_call = ""
      // }

      // update flag to temp singleton class to show B File Modal Automatically If comes here from Quick FollowUp Call BFile Action
      DataHandler.setQuickFollowUpCallFromBFileActionTemp(isQuickFollowUp);

      //Nullify user filled data
      data.first_name = "";
      data.last_name = "";
      data.email = "";

      data.cross_sell_policies_uncovered = 0,

        data.dob_dd = "";
      data.dob_mm = "";
      data.dob_yyyy = "";
      data.birthday = "";

      data.spouse_first_name = "";
      data.spouse_last_name = "";
      data.spouse_birthday = "";

      data.children = null;

      data.address = "";
      data.address_cont = "";
      data.city = "";
      data.state = "";
      data.zipcode = "";

      data.primary_vehicles_num = null;
      data.secondary_vehicles_toggle = "";
      data.secondary_vehicles = [];
      data.secondary_vehicles_value = "";

      data.step_insurance_question = null;
      data.step_insurance_question_spouse = null;

      data.home_mortgage_protection_toggle = "";
      data.home_mortgage_toggle = "0";
      data.secondary_home_mortgage_toggle = "";
      data.secondary_home_market_value = "";
      data.secondary_home_mortgage = "";
      data.secondary_home_type = "[]";
      data.secondary_vehicles = "[]",

        data.business_name = "";
      data.business_type = "";
      data.business_name_spouse = "";
      data.business_type_spouse = "";

      data.employer_name = "";
      data.employer_years = "";
      data.employed_anual_income = "";
      data.employed_length = null;

      data.employer_name_spouse = "";
      data.employer_years_spouse = "";
      data.employed_anual_income_spouse = "";
      data.employed_length_spouse = null;

      data.asset_401k_value = 0;
      data.asset_preservation_value = "";
      data.asset_total_value = "";

      data.retirement_plan = "";
      data.retirement_plan_value = "";
      data.retirement_dollars = 0;

      data.retirement_plan_spouse = "";
      data.retirement_plan_value_spouse = "";

      data.life_insurance_toggle_1 = null;
      data.life_insurance_toggle_2 = null;
      data.life_insurance_toggle_3 = null;

      data.notes = "";




      this.setState({ wizard: data, loading: false });
    });
  }



  componentDidMount = async () => {
    if (this.props.isExternalBFile) {
      localStorage.removeItem('wizard');
    }
    let skip = false;
    const { wizard } = this.state;
    // console.log(wizard);

    // set Duplicate Customer Callback
    DataHandler.setDuplicateCustomerCallback(this.checkDuplicateCustomer);

    this.setState({ loading: true });
    const agencyOwnerDetailsAPI = this.props.isExternalBFile
      ? `/api/get_agency_owner_details/external_rac?user_id=${this.props.extUserId}`
      : `/api/get_agency_owner_details`;
    const { data: { error_response, agency_owner_details, success } } = await axios.get(agencyOwnerDetailsAPI)
    if (success && !error_response) {
      this.setState({ agency_owner_details })
      if (agency_owner_details.carrier) {
        wizard.carrier = agency_owner_details.carrier;
        agency_owner_details.carrier === WIZARD.CARRIER.COUNTRY_FINANCIAL ? wizard.status = RENEWAL : NEW_BFILE // NOSONAR
      }
      this.setState({ loading: false });
    } else {
      if (!this.props.isExternalBFile) {
        message.error(error_response);
      }
      this.setState({ loading: false });
    }

    if (!this.props.isExternalBFile) {
      axios.get("/api/user").then((res) => {
        const user = res.data;
        // F.log("USSEERR =>", user);
        // if (user.carrier) {
        //   wizard.carrier = user.carrier;
        //   user.carrier === WIZARD.CARRIER.COUNTRY_FINANCIAL ? wizard.status = 'Renewal' : null
        // }
        // if(user.invited_user) this.state.wizard.carrier = user.invited_user.carrier
        if (user.user_agency_assoc.length > 0) {
          var agency_id = user.user_agency_assoc[0].agency_id;
          axios.get("/api/agencies/" + agency_id).then((res) => {
            const agency_res = res.data;

            // add agency details in wizard object
            const agency_name = agency_res.name;
            const agency_address = agency_res.address;
            let agency_email = null;
            let agency_phone = null;

            if (
              agency_res.hasOwnProperty("primary") &&
              agency_res.primary.hasOwnProperty("email")
            ) {
              agency_email = agency_res.primary.email;
            }

            if (
              agency_res.hasOwnProperty("primary") &&
              agency_res.primary.hasOwnProperty("phone")
            ) {
              agency_phone = agency_res.primary.phone;
            }

            const agency_info =
            {
              name: agency_name,
              address: agency_address,
              email: agency_email,
              phone: agency_phone,
              review: agency_res.review,
              vonboard: agency_res.vonboard,
              is_lead: agency_res.is_lead,
              is_opportunity: agency_res.is_opportunity
            }
            wizard.agency_info = agency_info;

            this.updateField("agency_info", agency_info);
            DataHandler.setTempHoldAgencyData({
              name: agency_name,
              address: agency_address,
              email: agency_email,
              phone: agency_phone,
              active: agency_res.active,
              calculator_only: agency_res.calculator_only,
              review: agency_res.review,
              vonboard: agency_res.vonboard
            });

            if (agency_res.calculator_only == 1) {
              this.setState({
                is_calculator_only: true
              });
            }
          });
        }
      });
    } else {
      this.setState({ loading: false });
      wizard.agency_id = Number(this.props.extAgencyId);
      wizard.user_id = Number(this.props.extUserId);
    }

    if ("wizard" in window.localStorage) {
      let wizard = JSON.parse(window.localStorage.wizard);
      const initWizard = (data) => {
        const rac = F.bfile_rac(data);
        F.log("Rac financial 1 =>" + rac.financial);
        data.ready = true;
        data.rac_calculator = rac.rac;
        data.rac_auto = rac.auto;
        data.rac_home = rac.home;
        data.toggle = "person";
        data.rac_financial = rac.financial;
        data.rac_financial_spouse = rac.financial_spouse;
        data.rac_income = rac.income;
        data.rac_income_spouse = rac.income_spouse;
        if (data.children === "") data.children = null;
        if (data.primary_vehicles_num === "") data.primary_vehicles_num = null;
        if (data.birthday !== "" && data.birthday !== null) {
          const birthday = data.birthday.split("/");
          if (parseInt(birthday[0], 10) < 10) {
            data.dob_mm = "0" + parseInt(birthday[0], 10);
          } else {
            data.dob_mm = birthday[0] + "";
          }
          // data.dob_dd = birthday[1] + "";
          data.dob_yyyy = birthday[2] + "";
          data.dob_age = F.getAge(new Date(data.birthday));
        }
        if (data.spouse_birthday !== "" && data.spouse_birthday !== null) {
          const spouse_birthday = data.spouse_birthday.split("/");
          if (parseInt(spouse_birthday[0], 10) < 10) {
            data.dob2_mm = "0" + parseInt(spouse_birthday[0], 10);
          } else {
            data.dob2_mm = spouse_birthday[0] + "";
          }
          data.dob2_yyyy = spouse_birthday[2] + "";
          data.dob2_age = F.getAge(new Date(data.spouse_birthday));
        }
        if (
          data.auto_policy_sold_effective_date !== "" &&
          data.auto_policy_sold_effective_date !== null
        ) {
          data.auto_policy_sold_effective_date = moment(
            data.auto_policy_sold_effective_date
          );
        }
        if (
          data.auto_policy_not_sold_expiration_date !== "" &&
          data.auto_policy_not_sold_expiration_date !== null
        ) {
          data.auto_policy_not_sold_expiration_date = moment(
            data.auto_policy_not_sold_expiration_date
          );
        }
        if (
          data.home_policy_sold_effective_date !== "" &&
          data.home_policy_sold_effective_date !== null
        ) {
          data.home_policy_sold_effective_date = moment(
            data.home_policy_sold_effective_date
          );
        }
        if (
          data.home_policy_not_sold_expiration_date !== "" &&
          data.home_policy_not_sold_expiration_date !== null
        ) {
          data.home_policy_not_sold_expiration_date = moment(
            data.home_policy_not_sold_expiration_date
          );
        }
        return data;
      };
      if (typeof this.props.match.params.bfile_id !== "undefined") {
        if (wizard.id === this.props.match.params.bfile_id) {
          skip = true;
          // F.log(
          //   "typeof this.props.match.params.bfile_id",
          //   typeof this.props.match.params.bfile_id
          // );
          wizard = initWizard(wizard);
          wizard.stepIndex =
            "bfileType" in window.localStorage &&
              window.localStorage.bfileType === "quick"
              ? 13
              : 1;

          if (wizard.stepIndex === 13) {
            wizard.isQuickFollowUpCallFromBFileAction = true
            // wizard.type_of_call = "FollowUp"
            // wizard.sub_type_of_call = ""
          }


        }
      } else {
        if (this.props.location.search.indexOf("new") < 0) {
          skip = true;
          // F.log("location", this.props.location.search.indexOf("new"));
          wizard = initWizard(wizard);
          wizard.stepIndex =
            "bfileType" in window.localStorage &&
              window.localStorage.bfileType === "quick"
              ? 13
              : 1;
          if (wizard.stepIndex === 13) {
            wizard.isQuickFollowUpCallFromBFileAction = true
            // wizard.type_of_call = "FollowUp"
            // wizard.sub_type_of_call = ""
          }
        }
      }
      this.setState({
        loading: false,
        wizard
      });
    }
    if (!skip) {
      if ((typeof this.props.match.params.bfile_id !== "undefined" && !this.props.isExternalBFile) ||
        (this.props.isExternalBFile && this.props.extWizardId)) {
        const bfile_id = this.props.isExternalBFile ? this.props.extWizardId : this.props.match.params.bfile_id;
        const apiURL = this.props.isExternalBFile ? `/api/bfile_token/external_rac/${bfile_id}` :
          `/api/b_file/${bfile_id}${this.state.user.user_type === 'SUPER_ADMIN' && `?user_type=${this.props.history.location.state.user_type}` || ''}`;
        const { user } = this.state;
        this.setState({ loading: true });
        axios.get(apiURL).then((res) => {
          const data = res.data;
          const rac = F.bfile_rac(data);
          if (data.user && !data.user.carrier) data.user.carrier = this.state.wizard.carrier
          F.log("Rac financial 2 =>" + rac.financial);
          // data.stepIndex = 1;
          data.stepIndex =
            "bfileType" in window.localStorage &&
              window.localStorage.bfileType === "quick"
              ? 13
              : 1;
          data.expiration_date_old = data.expiration_date;
          data.type_of_call_old = data.type_of_call;

          // if (type_of_call_format(data.type_of_call) === 'followup') {
          //   data.sub_type_of_call = get_label_from_value(data.sub_type_of_call, 'value', data.type_of_call) ? Array.from(new Set(('Thank You / Referrals,' + get_label_from_value(data.sub_type_of_call, 'value', data.type_of_call)).split(","))).join(",") : 'Thank You / Referrals'
          // } else {
          //   data.type_of_call = 'FollowUp';
          //   data.sub_type_of_call = 'Thank You / Referrals'
          // }



          if (data.stepIndex === 13) {
            data.isQuickFollowUpCallFromBFileAction = true
            // data.type_of_call = "FollowUp"
            // data.sub_type_of_call = ""
          }


          data.rac_calculator = rac.rac;
          data.agency_info = {
            ...this.state.agency_info,
            active: data.agency.active,
            calculator_only: data.agency.calculator_only,
            review: data.agency.review,
            vonboard: data.agency.vonboard,
            is_lead: data.agency.is_lead,
            is_opportunity: data.agency.is_opportunity
          }

          data.rac_auto = rac.auto;
          data.rac_home = rac.home;
          data.rac_financial = rac.financial;
          data.rac_financial_spouse = rac.financial_spouse;
          data.rac_customary_items = rac.customary_items;
          data.rac_income = rac.income;
          data.rac_income_spouse = rac.income_spouse;
          data.ready = true;
          data.mortgage_review_last = data.mortgage_review;
          data.carrier = data && data.user && data.user.carrier;
          data.status = "Renewal"
          if (data.children === "") data.children = null;
          if (data.primary_vehicles_num === "")
            data.primary_vehicles_num = null;
          data.dob_mm = "";
          data.dob_dd = "";
          data.dob_yyyy = "";
          data.dob_age = "";
          data.dob2_mm = "";
          data.dob2_yyyy = "";
          data.dob2_age = "";
          data.acknowledge = null;
          if (data.birthday !== "" && data.birthday !== null) {
            const birthday = data.birthday.split("/");
            if (parseInt(birthday[0], 10) < 10) {
              data.dob_mm = "0" + parseInt(birthday[0], 10);
            } else {
              data.dob_mm = birthday[0] + "";
            }
            // data.dob_dd = birthday[1] + "";
            data.dob_yyyy = birthday[2] + "";
            data.dob_age = F.getAge(new Date(data.birthday));
          }

          if (data.spouse_birthday !== "" && data.spouse_birthday !== null) {
            const spouse_birthday = data.spouse_birthday.split("/");
            if (parseInt(spouse_birthday[0], 10) < 10) {
              data.dob2_mm = "0" + parseInt(spouse_birthday[0], 10);
            } else {
              data.dob2_mm = spouse_birthday[0] + "";
            }
            data.dob2_yyyy = spouse_birthday[2] + "";
            data.dob2_age = F.getAge(new Date(data.spouse_birthday));
          }
          if (
            data.auto_policy_sold_effective_date !== "" &&
            data.auto_policy_sold_effective_date !== null
          ) {
            data.auto_policy_sold_effective_date = moment(
              data.auto_policy_sold_effective_date
            );
          }
          if (
            data.auto_policy_not_sold_expiration_date !== "" &&
            data.auto_policy_not_sold_expiration_date !== null
          ) {
            data.auto_policy_not_sold_expiration_date = moment(
              data.auto_policy_not_sold_expiration_date
            );
          }
          if (
            data.home_policy_sold_effective_date !== "" &&
            data.home_policy_sold_effective_date !== null
          ) {
            data.home_policy_sold_effective_date = moment(
              data.home_policy_sold_effective_date
            );
          }
          if (
            data.home_policy_not_sold_expiration_date !== "" &&
            data.home_policy_not_sold_expiration_date !== null
          ) {
            data.home_policy_not_sold_expiration_date = moment(
              data.home_policy_not_sold_expiration_date
            );
          }
          const policies = [];
          if (data.policies.length > 0) {
            for (var i = 0; i < data.policies.length; i++) {
              if (data.policies[i].policy_sold === null) {
                data.policies[i].policy_sold = "";
              }
              policies.push({
                type: data.policies[i].policy_type,
                sold: data.policies[i].policy_sold + "",
                policy: ""
              });
            }
          }
          data.policies = policies;
          if (data.asset_401k_accounts === '["None"]') {
            data.asset_401k_accounts_toggle = 0;
          } else if (
            data.asset_401k_accounts !== "" &&
            data.asset_401k_accounts !== "[]" &&
            data.asset_401k_accounts !== null
          ) {
            data.asset_401k_accounts_toggle = 1;
          }

          if (data.asset_401k_accounts_spouse === '["None"]') {
            data.asset_401k_accounts_toggle_spouse = 0;
          } else if (
            data.asset_401k_accounts_spouse !== "" &&
            data.asset_401k_accounts_spouse !== "[]" &&
            data.asset_401k_accounts_spouse !== null
          ) {
            data.asset_401k_accounts_toggle_spouse = 1;
          }

          let change_ownership_modal = false;
          if (typeof this.props.match.params.action !== "undefined") {
            const action = this.props.match.params.action;
            if (action === "renewal") {
              data.stepIndex = 0;
              data.status = "Renewal";
              if (data.parent_id === null || data.parent_id === "") {
                data.parent_id = data.id;
              }
              data.id = "";
              data.archive = 0;
              if (data.user_id !== user.id) {
                change_ownership_modal = true;
              }
            }
          }
          data.step_insurance_question = data.step_insurance_question ? data.step_insurance_question : null;
          // check if user comes here from Quick "Follow-Up Call" B File Profile Action ( update wizard state )
          const state = this.props.location.state;
          const isQuickFollowUp = state != null && state.quickFollowUp;

          data.completed_count = 0;

          //new insurance logic default value for different sections for edit case
          if (data.home_mortgage_protection_toggle === "" || data.home_mortgage_protection_toggle === null) {
            data.life_insurance_toggle_1 = null;
            data.life_insurance_toggle_2 = null;
            data.life_insurance_toggle_3 = null;
          } else {
            switch (data.insurance_set) {
              case "primary_home":
                data.life_insurance_toggle_1 = data.home_mortgage_protection_toggle;
                data.life_insurance_toggle_2 = "0";
                data.life_insurance_toggle_3 = "0";
                break;
              case "secondary_home":
                data.life_insurance_toggle_1 = "0";
                data.life_insurance_toggle_2 = data.home_mortgage_protection_toggle;
                data.life_insurance_toggle_3 = "0";
                break;
              case "financial":
                data.life_insurance_toggle_1 = "0";
                data.life_insurance_toggle_2 = "0";
                data.life_insurance_toggle_3 = data.home_mortgage_protection_toggle;
                break;
              default:
                data.life_insurance_toggle_1 = null;
                data.life_insurance_toggle_2 = null;
                data.life_insurance_toggle_3 = null;
            }
          }


          // update wizard state
          data.isQuickFollowUpCallFromBFileAction = isQuickFollowUp;

          // if(data.isQuickFollowUpCallFromBFileAction){
          //   data.type_of_call = "FollowUp"
          //   data.sub_type_of_call = ""
          // }

          // update flag to temp singleton class to show B File Modal Automatically If comes here from Quick FollowUp Call BFile Action
          DataHandler.setQuickFollowUpCallFromBFileActionTemp(isQuickFollowUp);

          this.setState(
            {
              loading: false,
              wizard: data,
              change_ownership_modal
            },
            () => {
              this.updatePolicies();
              if (this.props.isFromDirectUrl) {
                this.updateField("gotoStepIndex", 13)
              }

            }
          );
        });
      } else {
        const wizard = { ...this.state.wizard };
        const rac = F.bfile_rac(wizard);
        F.log("Rac financial 3 =>" + rac.financial);
        wizard.rac_calculator = rac.rac;
        wizard.rac_auto = rac.auto;
        wizard.rac_home = rac.home;
        wizard.rac_financial = rac.financial;
        wizard.rac_financial_spouse = rac.financial_spouse;
        wizard.rac_income = rac.income;
        wizard.rac_income_spouse = rac.income_spouse;
        wizard.ready = true;
        wizard.stepIndex =
          "bfileType" in window.localStorage &&
            window.localStorage.bfileType === "quick"
            ? 13
            : 1;

        if (wizard.stepIndex === 13) {
          wizard.isQuickFollowUpCallFromBFileAction = true
          // wizard.type_of_call = "FollowUp"
          // wizard.sub_type_of_call = ""

        }

        if (wizard.children === "") wizard.children = null;
        if (wizard.primary_vehicles_num === "")
          wizard.primary_vehicles_num = null;


        if (!this.props.isExternalBFile) {
          this.setState({ loading: true, wizard });
          axios
            .get("/api/user")
            .then((res) => {
              const u = res.data;
              for (let i = 0; i < u.user_agency_assoc.length; i++) {
                wizard.agency_id = u.user_agency_assoc[i].agency_id;
              }
              wizard.user_id = u.id;
              this.setState({ loading: false, wizard }, () => {
                this.saveWizard();
                if (this.props.isFromDirectUrl) {
                  this.updateField("gotoStepIndex", 13)
                }
              });
            })
            .catch(() => {
              message.error(F.translate("User not logged in."));
              this.props.history.push("/login");
            });
        } else {
          this.setState({ loading: false });
          wizard.agency_id = Number(this.props.extAgencyId);
          wizard.user_id = Number(this.props.extUserId);
        }

      }
    }
  };

  saveWizard() {
    const { wizard } = this.state;
    window.localStorage.wizard = JSON.stringify(wizard);
  }

  componentDidUpdate() {
    // const { wizard } = this.state;
    const wizard = { ...this.state.wizard };
    if (typeof this.props.match.params !== "undefined" && wizard.ready) {
      const params = this.props.match.params;
      if ("step" in params) {
        const stepIndex = parseInt(params.step);
        if (this.state.last_index != stepIndex) {
          wizard.stepIndex = stepIndex;
          this.setState({
            wizard,
            last_index: stepIndex
          });
        }
      }
    }
  }

  componentWillUnmount() {
    this.saveWizard();
    DataHandler.setTempHoldAgencyData(null);
  }

  //trigger point for completed count
  complete = () => {
    const { wizard } = this.state;
    if ((wizard.completed_count === 0 || !wizard.completed) && wizard.id !== "") {
      axios.post("/api/calculator_completed_history", {
        "bfile_id": wizard.id,
        "bfile_user_id": this.state.user.id,
        "agency_id": wizard.agency_id,
        "type_of_call": wizard.type_of_call || "FollowUp",
        "sub_type_of_call": wizard.sub_type_of_call || "Thank You / Referrals",
        "first_name": wizard.first_name,
        "last_name": wizard.last_name,
        "phone": wizard.phone,
      })
      this.updateField("completed", true);
      this.updateRadioBtnToggle(true)
    }
  }
  updateField = (name, value, old_value) => {
    const { wizard } = this.state;

    if (name === 'steperror') {
      wizard.error = value;
    }

    //new logic for life insurance
    if (name === "step_insurance_question") {
      wizard.step_insurance_question = value
    }

    if (name === "life_insurance_toggle_1" && value === "1") {
      wizard.life_insurance_toggle_3 = "0";
      wizard.life_insurance_toggle_2 = "0";
    }

    if (name === "life_insurance_toggle_2" && value === "1") {
      wizard.life_insurance_toggle_1 = "0";
      wizard.life_insurance_toggle_3 = "0";
    }

    if (name === "life_insurance_toggle_3" && value === "1") {
      wizard.life_insurance_toggle_1 = "0";
      wizard.life_insurance_toggle_2 = "0";
    }

    if (name === "life_insurance_toggle_1" && value === "0") {
      wizard.life_insurance_toggle_3 = null;
      wizard.life_insurance_toggle_2 = null;
      wizard.home_mortgage_protection_policy_spouse = "[]";
      wizard.home_mortgage_protection_benefit_spouse = "";
    }

    if (name === "life_insurance_toggle_2" && value === "0") {
      wizard.life_insurance_toggle_3 = null;
      wizard.home_mortgage_protection_policy_spouse = "[]";
      wizard.home_mortgage_protection_benefit_spouse = "";
    }

    if (name === "life_insurance_toggle_3" && value === "0") {
      wizard.life_insurance_toggle_3 = "0";
      wizard.life_insurance_toggle_2 = "0";
      wizard.home_mortgage_protection_policy_spouse = "[]";
      wizard.home_mortgage_protection_benefit_spouse = "";
    }



    if (name === "stepIndex") {
      if (typeof old_value === "undefined") old_value = value;
      if (wizard.stepIndex >= old_value) {
        if (!validationCheck(wizard, (name, value) => this.updateField(name, value), name)) {
          return false;
        }
      }
    }

    if (name === "isSentBfile") {
      wizard.isSentBfile = value
    }

    if (name === "insurance_set") {
      wizard.insurance_set = value
    }

    if (name === "gotoStepIndex") {
      validationCheck(wizard, (name, value) => this.updateField(name, value), name)
      name = "stepIndex";
    }
    // F.log("Name =>", name);
    // F.log("value =>", value);
    wizard[name] = value;

    if (name === "primary_vehicles_num") {
      if (value && value > 0) {
        wizard.primary_vehicles_toggle = "1";
      } else {
        wizard.primary_vehicles_toggle = "0";
      }
    }

    if (
      // (name === "dob_mm" || name === "dob_yyyy" || name === "dob_dd") &&
      (name === "dob_mm" || name === "dob_yyyy") &&
      wizard.dob_mm !== "" &&
      wizard.dob_yyyy !== ""
      //  && wizard.dob_dd !== ""
    ) {
      wizard.birthday = wizard.dob_mm.split("-")[0] + "/" + wizard.dob_dd + "/" + wizard.dob_yyyy;
      wizard.dob_age = F.getAge(new Date(wizard.birthday));
    }

    if (
      (name === "dob2_mm" || name === "dob2_yyyy") &&
      wizard.dob2_mm !== "" &&
      wizard.dob2_yyyy !== ""
    ) {
      wizard.spouse_birthday = wizard.dob2_mm.split("-")[0] + "/01/" + wizard.dob2_yyyy;
      wizard.dob2_age = F.getAge(new Date(wizard.spouse_birthday));
    }

    if (name === "secondary_vehicles" || name === "secondary_home_type") {
      this.updatePolicies();
    }

    if (name === "policies") {
      let uncovered = 0;
      let sold = 0;
      let quoted = 0;
      let umbrella_sold = 0;
      let umbrella_uncovered = 0;
      let umbrella_quoted = 0;
      for (let i = 0; i < wizard.policies.length; i++) {
        if (wizard.policies[i].sold !== "1") {
          uncovered++;
        }
        if (wizard.policies[i].sold === "1") {
          sold++;
        }
        if (wizard.policies[i].quoted === "1") {
          quoted++;
        }

        if (wizard.policies[i].type === "Umbrella") {
          // wizard.policy_umbrella_total = 1;
          if (wizard.policies[i].sold === "1") {
            umbrella_sold++;
          }
          if (wizard.policies[i].sold === "0") {
            umbrella_uncovered++;
          }
          if (wizard.policies[i].sold === "2") {
            umbrella_quoted++;
          }
        }
      }

      wizard.cross_sell_policies_uncovered = uncovered;
      wizard.cross_sell_opportunities_quoted = quoted;
      wizard.cross_sell_opportunities_sold = sold;

      wizard.umbrella_policy_sold = umbrella_sold;
      wizard.umbrella_policy_uncovered = umbrella_uncovered;
      wizard.umbrella_policy_quoted = umbrella_quoted;
    }

    if (name === "home_mortgage") {
      if (value === "") {
        wizard.home_mortgage_toggle = "0";
        wizard.home_mortgage_protection_benefit = "";
      } else {
        wizard.home_mortgage_toggle = "1";
      }
    }

    if (name === "home_toggle") {
      wizard.had_mortgage_review = null;
      wizard.mortgage_purchase_home = null;
      wizard.mortgage_review = null;

      if (value === "3") {
        wizard.home_mortgage = "";
      }
    }

    if (name === "secondary_home_mortgage") {
      if (value === "") {
        wizard.secondary_home_mortgage_toggle = "0";
      } else {
        wizard.secondary_home_mortgage_toggle = "1";
      }
    }

    if (name === "business_owner_toggle") {
      wizard.asset_401k_accounts = "[]";
      wizard.asset_401k_accounts_toggle = null;
      wizard.asset_preservation_value = "";
    }
    if (name === "business_owner_spouse_toggle") {
      wizard.asset_401k_accounts_spouse = "[]";
      wizard.asset_401k_accounts_toggle_spouse = null;
      wizard.asset_preservation_value_spouse = "";
    }
    if (name === "business_owner_toggle" && value === "0") {
      wizard.business_name = "";
      wizard.business_type = "";
      wizard.employees_count = null;
      wizard.business_type_other = "";
    }
    if (name === "business_owner_spouse_toggle" && value === "0") {
      wizard.business_name_spouse = "";
      wizard.business_type_spouse = "";
      wizard.employees_count_spouse = null;
      wizard.business_type_other_spouse = "";
    }
    if (name === "business_owner_toggle" && value === "1") {
      wizard.employer_name = "";
      wizard.employer_retire_from = "";
      wizard.employer_years = "";
      wizard.employed_toggle = "";
    }

    if (name === "business_owner_spouse_toggle" && value === "1") {
      wizard.employer_name_spouse = "";
      wizard.employer_retire_from_spouse = "";
      wizard.employer_years_spouse = "";
      wizard.employed_toggle_spouse = "";
    }
    if (name === "employed_toggle" && value === "1") {
      wizard.employer_retire_from = "";
    }
    if (name === "employed_toggle" && value === "0") {
      wizard.employer_name = "";
      wizard.employer_years = "";

      if (wizard.employed_retired_disabled !== "Retired") {
        wizard.employer_retire_from = "";
      }
    }
    if (name === "employed_toggle_spouse" && value === "1") {
      wizard.employer_retire_from_spouse = "";
    }

    if (name === "employed_toggle_spouse" && value === "0") {
      wizard.employer_name_spouse = "";
      wizard.employer_years_spouse = "";
      if (wizard.employed_retired_disabled_spouse !== "Retired") {
        wizard.employer_retire_from_spouse = "";
      }
    }

    if (name === "secondary_home_toggle" && value === "0") {
      wizard.secondary_home_type = "[]";
      wizard.secondary_home_market_value = "";
      wizard.secondary_home_mortgage = "";
    }

    if (name === "personal_property_toggle" && value === 0) {
      wizard.personal_property_type = "[]";
      wizard.personal_property_value = "";
    }

    if (name === "home_toggle" && (value === "0" || value === "2")) {
      wizard.home_market_value = "";
      wizard.home_mortgage = "";
    }

    if (name === "secondary_home_mortgage_toggle" && value === "0") {
      wizard.secondary_home_mortgage = "";
    }

    if ((((name === "home_toggle" && (value === "0" || value === "2")) || (wizard.home_mortgage_toggle === "0")) && wizard.insurance_set === "primary_home") || ((((name === "secondary_home_toggle" || name === "secondary_home_mortgage_toggle") && value === "0") || (wizard.secondary_home_mortgage_toggle === "0")) && wizard.insurance_set === "secondary_home")) {

      wizard.home_mortgage_protection_policy = "[]";
      wizard.home_mortgage_protection_benefit = "";
      wizard.home_mortgage_protection_policy_spouse = "[]";
      wizard.home_mortgage_protection_benefit_spouse = "";

      if (wizard.insurance_set === "secondary_home") {
        wizard.home_mortgage_protection_toggle = "0";
        wizard.life_insurance_toggle_1 = "0";
        wizard.life_insurance_toggle_2 = null;
        wizard.life_insurance_toggle_3 = null;
      } else {
        wizard.home_mortgage_protection_toggle = null;
        wizard.life_insurance_toggle_1 = null;
        wizard.life_insurance_toggle_2 = null;
        wizard.life_insurance_toggle_3 = null;
      }
    }

    if (name === "home_mortgage_protection_toggle" && value === "0") {
      wizard.home_mortgage_protection_policy = "[]";
      wizard.home_mortgage_protection_benefit = "";
    }

    if (name === "home_toggle" && value === "0") {
      validationCheck(wizard, (name, value) => this.updateField(name, value), name)
      wizard.stepIndex += 2;
      wizard.mortgage_purchase_home = null;
      wizard.mortgage_review = null;
      wizard.had_mortgage_review = null;
    }

    if (name === "home_toggle" && value === "2") {
      validationCheck(wizard, (name, value) => this.updateField(name, value), name)
      wizard.stepIndex += 2;
    }

    if (name === "secondary_home_toggle" && value === "0") {
      validationCheck(wizard, (name, value) => this.updateField(name, value), name)
      wizard.stepIndex += 2;
    }

    if (name === "business_owner_toggle" && value === "0") {
      wizard.stepIndex++;
    }

    // if (name === "business_owner_spouse_toggle" && value === "0") {
    //   wizard.stepIndex++;
    // }

    if (name === "secondary_vehicles_toggle" && value === "0") {
      validationCheck(wizard, (name, value) => this.updateField(name, value), name)
      wizard.stepIndex++;
      wizard.secondary_vehicles = "[]";
      wizard.secondary_vehicles_value = "";
    }

    if (name === "children" && value !== "" && value !== null) {
      validationCheck(wizard, (name, value) => this.updateField(name, value), name)
      wizard.stepIndex++;
    }

    if (name === "personal_property_toggle" && value === 0) {
      validationCheck(wizard, (name, value) => this.updateField(name, value), name)
      wizard.stepIndex++;
    }

    if (name === "auto_sold_toggle" && (value === "1" || value === "2")) {
      wizard.auto_policy_not_sold_current_carrier = "";
      wizard.auto_policy_not_sold_expiration_date = null;
    }
    if (name === "home_sold_toggle" && (value === "1" || value === "2")) {
      wizard.home_policy_not_sold_current_carrier = "";
      wizard.home_policy_not_sold_expiration_date = null;
    }

    if (name === "auto_sold_toggle" && (value === "0" || value === "2")) {
      wizard.auto_policy_sold_term = "";
      wizard.auto_policy_sold_effective_date = null;
    }
    if (name === "home_sold_toggle" && (value === "0" || value === "2")) {
      wizard.home_policy_sold_term = "";
      wizard.home_policy_sold_effective_date = null;
    }

    if (name === "asset_401k_accounts_toggle" && value === 0) {
      // validationCheck(wizard, (name, value) => this.updateField(name, value), name)
      wizard.asset_401k_accounts = '["None"]';
      wizard.asset_preservation_value = "";
      // wizard.stepIndex += 2;
      // wizard.stepIndex = Math.min(11, wizard.stepIndex);
    }

    if (name === "asset_401k_accounts_toggle_spouse" && value === 0) {
      wizard.asset_401k_accounts_spouse = '["None"]';
      wizard.asset_preservation_value_spouse = "";
      // wizard.stepIndex += 2;
      // wizard.stepIndex = Math.min(11, wizard.stepIndex);
    }

    if (name === "coverage") {
      wizard.coverage = value
    }

    if (name === "stepIndex") {
      if (typeof old_value === "undefined") old_value = value;
      if (value === 10 && wizard.business_owner_toggle === "1") {
        if (wizard.stepIndex >= old_value) {
          wizard.stepIndex++;
        } else {
          wizard.stepIndex--;
        }
      }
      if (value === 7 && wizard.secondary_home_toggle === "0") {
        if (wizard.stepIndex >= old_value) {
          wizard.stepIndex++;
        } else {
          wizard.stepIndex--;
        }
      }
      if (value === 5 && ["0", "2"].includes(wizard.home_toggle)) {
        if (wizard.stepIndex >= old_value) {
          wizard.stepIndex++;
        } else {
          wizard.stepIndex--;
        }
      }
    }

    const rac = F.bfile_rac(wizard);
    F.log("Rac financial 4 =>" + rac.financial);
    wizard.rac_calculator = rac.rac;
    wizard.rac_auto = rac.auto;
    wizard.rac_home = rac.home;
    wizard.rac_financial = rac.financial;
    wizard.rac_financial_spouse = rac.financial_spouse;
    wizard.rac_customary_items = rac.customary_items;
    wizard.rac_income = rac.income;
    wizard.rac_income_spouse = rac.income_spouse;

    if (name != 'agency_info' && window.location.hash.split("/").includes("wizard?new") &&
      !wizard.type_of_call
      // (wizard.status == NEW_BFILE || wizard.carrier === WIZARD.CARRIER.COUNTRY_FINANCIAL)
      && value) {
      wizard.is_saved_for_later = 1;
    }






    this.setState(wizard, () => {
      this.saveWizard();
      if (!this.props.isExternalBFile) {
        if (name === "stepIndex") {
          this.props.history.replace({ pathname: "/wizard/step/" + wizard.stepIndex, state: { isFromDirectUrl: this.props.isFromDirectUrl || false, ...this.props.history.location.state } });
        } else {
          if (typeof this.props.match.params !== "undefined") {
            const params = this.props.match.params;
            if ("step" in params) {
              const stepIndex = parseInt(params.step);
              if (stepIndex !== wizard.stepIndex) {
                this.props.history.replace({ pathname: "/wizard/step/" + wizard.stepIndex, state: { ...this.props.history.location.state } });
              }
            }
          }
        }
      }
    });
  };

  createData(wizard, policies, totalPnCItems) {
    const data = {
      agency_id: wizard.agency_id,
      acknowledge_by: wizard.acknowledge_by,
      first_name: wizard.first_name,
      address: wizard.address,
      address_cont: wizard.address_cont,
      business_name: wizard.business_name,
      business_name_spouse: wizard.business_name_spouse,

      business_owner_toggle: wizard.business_owner_toggle,
      business_owner_spouse_toggle: wizard.business_owner_spouse_toggle,

      business_type_spouse: wizard.business_type_spouse,
      business_type_other_spouse: wizard.business_type_other_spouse,

      business_type: wizard.business_type,
      business_type_other: wizard.business_type_other, // new add

      //added bfile_sub
      bfile_sub: wizard.bfile_sub,

      employed_toggle: wizard.employed_toggle, // new add
      employed_toggle_spouse: wizard.employed_toggle_spouse,
      employer_name: wizard.employer_name, // new add
      employer_name_spouse: wizard.employer_name_spouse,
      employer_years: wizard.employer_years, // new add
      employer_years_spouse: wizard.employer_years_spouse,
      employed_anual_income: wizard.employed_anual_income,
      employed_anual_income_spouse: wizard.employed_anual_income_spouse,

      city: wizard.city,
      email: wizard.email,
      employed_retired_disabled: wizard.employed_retired_disabled,
      employed_retired_disabled_spouse: wizard.employed_retired_disabled_spouse,
      employer_retire_from: wizard.employer_retire_from,
      employer_retire_from_spouse: wizard.employer_retire_from_spouse,
      home_market_value: wizard.home_market_value,
      home_mortgage: wizard.home_mortgage,
      home_mortgage_protection_toggle: wizard.home_mortgage_protection_toggle,
      home_mortgage_protection_benefit: wizard.home_mortgage_protection_benefit,
      home_mortgage_toggle: wizard.home_mortgage_toggle,
      home_mortgage_protection_policy: wizard.home_mortgage_protection_policy,
      home_toggle: wizard.home_toggle,
      insurance_score: wizard.insurance_score,
      last_name: wizard.last_name,
      spouse_last_name: wizard.spouse_last_name,
      // phone: wizard.phone,
      phone: F.removeFormatterFromPhoneNumber(wizard.phone),
      retirement_plan: wizard.retirement_plan,
      retirement_plan_value: wizard.retirement_plan_value,
      retirement_plan_spouse: wizard.retirement_plan_spouse,
      retirement_plan_value_spouse: wizard.retirement_plan_value_spouse,
      secondary_home_market_value: wizard.secondary_home_market_value,
      secondary_home_mortgage: wizard.secondary_home_mortgage,
      secondary_mortgage_protection_benefit:
        wizard.secondary_mortgage_protection_benefit,
      secondary_mortgage_protection_policy:
        wizard.secondary_mortgage_protection_policy,
      secondary_mortgage_protection_toggle:
        wizard.secondary_mortgage_protection_toggle,
      secondary_home_mortgage_toggle: wizard.secondary_home_mortgage_toggle,
      secondary_home_toggle: wizard.secondary_home_toggle,
      secondary_home_type: wizard.secondary_home_type,
      personal_property_toggle: wizard.personal_property_toggle,
      personal_property_value: wizard.personal_property_value,
      primary_vehicles_toggle: wizard.primary_vehicles_toggle,
      primary_vehicles_num: wizard.primary_vehicles_num,
      secondary_vehicles_toggle: wizard.secondary_vehicles_toggle,
      secondary_vehicles_value: wizard.secondary_vehicles_value,
      secondary_vehicles: wizard.secondary_vehicles,
      spouse_first_name: wizard.spouse_first_name,
      spouse_toggle: wizard.spouse_toggle,
      type_of_call: wizard.type_of_call ? wizard.type_of_call : this.props.isExternalBFile ? PROSPECT : "",
      // type_of_call: wizard.type_of_call ? wizard.type_of_call : PROSPECT,
      sub_type_of_call: wizard.sub_type_of_call,
      asset_total_value: wizard.asset_total_value,
      asset_total_value_spouse: wizard.asset_total_value_spouse,
      zipcode: wizard.zipcode,
      state: wizard.state,
      asset_preservation_toggle: wizard.asset_preservation_toggle,
      asset_preservation_value: wizard.asset_preservation_value,
      asset_preservation_toggle_spouse: wizard.asset_preservation_toggle_spouse,
      asset_preservation_value_spouse: wizard.asset_preservation_value_spouse,
      life_opportunities: wizard.life_opportunities,
      no_policies_sold: wizard.no_policies_sold,
      // policy_umbrella_total: wizard.policy_umbrella_total,
      policy_umbrella_total: wizard.umbrella_limit !== "" ? 1 : 0,
      //rollover_dollars_created: wizard.rollover_dollars_created,
      rollover_opportunities: wizard.rollover_opportunities,
      status: wizard.status,
      quote_auto_toggle: wizard.quote_auto_toggle,
      auto_sold_toggle: wizard.auto_sold_toggle,
      quote_home_toggle: wizard.quote_home_toggle,
      employees_count: wizard.employees_count,
      employees_count_spouse: wizard.employees_count_spouse,
      home_sold_toggle: wizard.home_sold_toggle,
      cross_sell_policies_uncovered: totalPnCItems < 0 ? 0 : totalPnCItems,
      cross_sell_opportunities_quoted: wizard.cross_sell_opportunities_quoted,
      cross_sell_opportunities_sold: wizard.cross_sell_opportunities_sold,
      umbrella_policy_quoted: wizard.umbrella_policy_quoted,
      umbrella_policy_sold: wizard.umbrella_policy_sold,
      umbrella_policy_uncovered: wizard.umbrella_policy_uncovered,
      umbrella_limit: wizard.umbrella_limit,
      attempts: wizard.attempts,
      action: wizard.action,
      call_type: wizard.call_type,
      callback_time: wizard.callback_time,
      vip: wizard.vip,
      children: wizard.children,
      need_attention: wizard.need_attention,
      birthday: wizard.birthday && wizard.birthday != null && wizard.birthday != undefined ? wizard.birthday.split(" ").join("") : "",
      spouse_birthday: wizard.spouse_birthday && wizard.spouse_birthday != null && wizard.spouse_birthday != undefined ? wizard.spouse_birthday.split(" ").join("") : "",
      phone2: wizard.phone2,
      auto_policy_sold_current_liability_limit:
        wizard.auto_policy_sold_current_liability_limit,
      auto_policy_sold_bfile_limit: wizard.auto_policy_sold_bfile_limit,
      auto_policy_sold_liability_limit_sold:
        wizard.auto_policy_sold_liability_limit_sold,
      auto_policy_sold_items_sold: wizard.auto_policy_sold_items_sold,
      auto_policy_sold_policy_premium: wizard.auto_policy_sold_policy_premium,
      auto_policy_sold_term: wizard.auto_policy_sold_term,
      auto_policy_not_sold_current_carrier:
        wizard.auto_policy_not_sold_current_carrier,
      auto_policy_not_sold_current_liability_limit:
        wizard.auto_policy_not_sold_current_liability_limit,
      auto_policy_not_sold_expiration_date:
        wizard.auto_policy_not_sold_expiration_date,
      home_policy_sold_liability_limit: wizard.home_policy_sold_liability_limit,
      home_policy_sold_bfile_limit: wizard.home_policy_sold_bfile_limit,
      home_policy_sold_liability_limit_sold:
        wizard.home_policy_sold_liability_limit_sold,
      home_policy_sold_items_sold: wizard.home_policy_sold_items_sold,
      home_policy_sold_policy_premium: wizard.home_policy_sold_policy_premium,
      home_policy_sold_term: wizard.home_policy_sold_term,
      home_policy_not_sold_current_carrier:
        wizard.home_policy_not_sold_current_carrier,
      home_policy_not_sold_current_liability_limit:
        wizard.home_policy_not_sold_current_liability_limit,
      home_policy_not_sold_expiration_date:
        wizard.home_policy_not_sold_expiration_date,
      auto_policy_sold_effective_date: wizard.auto_policy_sold_effective_date,
      home_policy_sold_effective_date: wizard.home_policy_sold_effective_date,
      is_lead: wizard.is_lead,
      is_saved_for_later: wizard.is_saved_for_later,
      is_requote: wizard.is_requote,
      is_renewal: wizard.is_renewal,
      is_onboarded: wizard.is_onboarded,
      nosalearchive_expiration_date: wizard.nosalearchive_expiration_date,
      facebook: wizard.facebook,
      twitter: wizard.twitter,
      linkedin: wizard.linkedin,
      profile_photo: wizard.profile_photo,
      archive: wizard.archive,
      user_id: wizard.user_id,
      parent_id: wizard.parent_id,
      bfile_folow_up_completed: null,
      bfile_review_completed: 0,
      //vonboard: wizard.vonboard,
      financial_id: wizard.financial_id,
      onboarding_id: wizard.onboarding_id,
      asset_401k_accounts: wizard.asset_401k_accounts,
      asset_401k_accounts_spouse: wizard.asset_401k_accounts_spouse,
      asset_accounts: wizard.asset_accounts,
      asset_accounts_spouse: wizard.asset_accounts_spouse,
      asset_account_spouse: wizard.aseet_account_spouse,
      personal_property_type: wizard.personal_property_type,
      policies: policies,
      liability_calculator_value: wizard.rac_calculator,
      onboarder_id: wizard.onboarder_id,
      vo_sent_date: wizard.vo_sent_date,
      mortgage_review: wizard.mortgage_review,
      mortgage_purchase_home: wizard.mortgage_purchase_home,
      had_mortgage_review: wizard.had_mortgage_review,
      no_follow_up: wizard.no_follow_up,
      // new add
      asset_401k_accounts_toggle: wizard.asset_401k_accounts_toggle,
      asset_401k_accounts_toggle_spouse:
        wizard.asset_401k_accounts_toggle_spouse,
      asset_401k_value: wizard.asset_401k_value,
      home_mortgage_protection_benefit_spouse: wizard.home_mortgage_protection_benefit_spouse,
      home_mortgage_protection_policy_spouse: wizard.home_mortgage_protection_policy_spouse,
      completed: wizard.completed,

      // new add for primary home
      step_insurance_question: wizard.step_insurance_question,
      insurance_set: wizard.insurance_set,
      zillow_address: wizard.zillow_address,
      zillow_estimated_value: wizard.zillow_estimated_value,
      secondary_zillow_address: wizard.secondary_zillow_address,
      secondary_zillow_estimated_value: wizard.secondary_zillow_estimated_value,
      vonboard: wizard.type_of_call && ['followup', 'prospect'].includes(wizard.type_of_call.split('-').join().toLowerCase()) ? 1 : 0,
      review: wizard.review || wizard.type_of_call && ['Review'].includes(wizard.type_of_call.split('-').join().toLowerCase()) ? 1 : 0,
      ...(this.state.wizard.isSentBfile ? {
        // rs_effective_date: wizard.expiration_date,
        // expiration_date: wizard.expiration_date ? moment(wizard.expiration_date).add(30, "days").format('YYYY-MM-DD') : null,
      } : {}),
      ...(wizard.vob_archived === 1 ? { vob_archived: null, onboarding_user: null, onboarding_id: null } : {}),
    };

    return data;
  }

  saveExternalBFileRac = async (wizard, data) => {
    try {
      this.updateLoadingState(true);
      let response;
      if (wizard.id) {
        response = await axios.put(`/api/bfile_token/external_rac/${wizard.id}`, data);
      } else {
        response = await axios.post("/api/bfile_token/external_rac", data);
      }

      this.updateLoadingState(false);

      if (response && response.data && response.data.id) {
        let bfile = response.data;
        await this.saveNotesExternalBFile(wizard, response);
        // this.update_RAC_Dates(wizard, response);
        console.log(wizard.id);
        if (!wizard.id) {
          await axios.post(EXTERNAL_RAC_UPLOAD_HISTORY,
            {
              bfile_id: bfile.id,
              bfile_user_id: bfile.user_id,
              creator_user_id: bfile.user_id,
              modifier_user_id: bfile.user_id,
              agency_id: bfile.agency_id,
              type_of_call: bfile.type_of_call,
              sub_type_of_call: bfile.sub_type_of_call,
              first_name: bfile.first_name,
              last_name: bfile.last_name,
              phone: bfile.phone,
            }
          );
        }
      }

      return response;
    } catch (error) {
      this.updateLoadingState(false);
      console.error("Error saving external B file Intelligence Link:", error);
      this.updateField("stepIndex", wizard.stepIndex + 1, wizard.stepIndex);
      setTimeout(() => this.smoothscroll(), 50);
      throw error;
    }
  };




  saveNotesExternalBFile = async (wizard, response) => {
    try {
      const bfileId = response.data.id;
      this.setState(prevState => ({
        wizard: {
          ...prevState.wizard,
          id: bfileId
        }
      }));
      const data = {
        bfile_id: bfileId,
        note: `${NOTE_PREFIX} ${wizard.first_name} ${wizard.last_name}`,
        user_id: this.props.extUserId,
        action: SEND_BFILE,
        type_of_call: wizard.type_of_call ? wizard.type_of_call : PROSPECT,
        sub_type_of_call: wizard.sub_type_of_call ? wizard.sub_type_of_call : RE_QUOTE,
      };

      this.updateLoadingState(true);

      const apiResponse = await axios.post("/api/bfile_notes/external_rac", data);

      this.updateField("stepIndex", wizard.stepIndex + 1, wizard.stepIndex);
      setTimeout(() => this.smoothscroll(), 50);

      this.updateLoadingState(false);

      return apiResponse;
    } catch (error) {
      this.updateLoadingState(false);
      console.error("Error saving external notes:", error);

      this.updateField("stepIndex", wizard.stepIndex + 1, wizard.stepIndex);
      setTimeout(() => this.smoothscroll(), 50);

      throw error;
    }
  };

  update_RAC_Dates = async (wizard, response) => {
    try {
      const bfileId = response && response.data && response.data.id;
      this.setState(prevState => ({
        wizard: {
          ...prevState.wizard,
          id: bfileId
        }
      }));
      if (!bfileId) {
        console.error("No bfileId found in response");
        return;
      }

      const payload = {
        fs_effective_date: moment().format("YYYY-MM-DD"),
      };

      const res = await axios.put(UPDATE_RAC_DATE(bfileId), payload);
      return res;
    } catch (error) {
      console.error("Error updating Intelligence Link Dates:", error);
      throw error;
    }
  };



  timer = null;

  // Custom debounce function as a class property
  debounce = (func, delay) => {
    return (...args) => {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  saveBFileRAC = async (wizard, data) => {
    try {
      let ajax;
      if (wizard.id) {
        ajax = axios.put(`/api/b_file/${wizard.id}`, data);
      } else {
        this.updateLoadingState(true);
        ajax = axios.post("/api/b_file", data);
      }
      const response = await ajax;
      this.updateLoadingState(false);
      if (!wizard.id && response.data.id) {
        //new rac
        this.updateField("id", response.data.id);
        this.props.setWizardValue({ isWizardValueUpdated: true });
      } else if (wizard.id && response.data.id && wizard.is_saved_for_later == 1 && !wizard.call_type
        //wizard.status === RENEWAL
      ) {
        //saved for later rac
        this.props.setWizardValue({ isWizardValueUpdated: true });
      } else if (wizard.id && response.data.id && wizard.is_saved_for_later == 0 && wizard.call_type
        //wizard.status === RENEWAL
      ) {
        //already saved rac
        this.props.setWizardValue({ isWizardValueUpdated: true });
      }

    } catch (error) {
      this.updateLoadingState(false);
    }
  }

  updateRadioBtnToggle = async (complete = false) => {
    if (!this.props.isExternalBFile) {
      const { wizard, user } = this.state;
      const phoneInputValue = wizard.phone && wizard.phone.replace(/\D/g, '');
      if (wizard.first_name && wizard.last_name && wizard.phone && phoneInputValue.length == 10) {


        const policies = [];
        for (var i = 0; i < wizard.policies.length; i++) {
          if (wizard.policies[i].sold === "") {
            wizard.policies[i].sold = null;
          }
          policies.push({
            policy_sold: wizard.policies[i].sold,
            policy_type: wizard.policies[i].type
          });
        }
        const totalPnCItems =
          wizard.cross_sell_policies_uncovered +
          wizard.primary_vehicles_num +
          (wizard.home_toggle === "1" || wizard.home_toggle === "2" ? 1 : 0);

        const data = this.createData(wizard, policies, totalPnCItems);

        //to mark any bfile complete when calculate coverage button is hit and stats update on dashboard accordingly
        if (complete || wizard.completed) {
          data.is_saved_for_later = 0;
          data.completed = 1;
          data.umbrella_limit = 1;
        }
        //data.is_saved_for_later = 1;
        else {
          if (!wizard.type_of_call
            // wizard.status == NEW_BFILE || wizard.carrier === WIZARD.CARRIER.COUNTRY_FINANCIAL
          ) {
            data.is_saved_for_later = 1;
          } else if (
            //wizard.status == RENEWAL 
            wizard.type_of_call
            &&
            wizard.is_saved_for_later == 0
          ) {
            data.is_saved_for_later = 0;
          } else if (
            //wizard.status == RENEWAL
            !wizard.type_of_call // NOSONAR
            &&
            wizard.is_saved_for_later == 1) { // NOSONAR
            data.is_saved_for_later = 1; // NOSONAR
          }
        }
        this.debounce(this.saveBFileRAC, 300)(wizard, data);
      }
    }
  }




  handleBlur = async (name, value) => {
    if (!this.props.isExternalBFile) {
      const { wizard } = this.state;
      const phoneInputValue = wizard.phone && wizard.phone.replace(/\D/g, '');
      if (wizard.first_name && wizard.last_name && wizard.phone && phoneInputValue.length == 10) {

        if (wizard.email && wizard.email !== "") {
          if (!F.validateEmail(wizard.email)) {
            message.error("Email address is invalid.");
            this.updateLoadingState(false);
            wizard.email = "";
            let wiz = JSON.parse(window.localStorage.getItem("wizard")) || {};
            wiz.email = "";
            window.localStorage.setItem("wizard", JSON.stringify(wiz));
          }
        }

        if (name === "dob_mm" || name === "dob_yyyy") {
          wizard.birthday = wizard.dob_mm.split("-")[0] + "/" + wizard.dob_dd + "/" + wizard.dob_yyyy;
        }

        // if (name === "email") {
        //   if (value && !F.validateEmail(value)) {
        //     message.error(EMAIL_ADDRESS_IS_INVALID);
        //     return;
        //   }
        // }

        // if (value ) {
        let is_saved_forlater;
        if (wizard.completed) {
          is_saved_forlater = 0;
        } else {
          if (!wizard.type_of_call
            //wizard.status == NEW_BFILE || wizard.carrier === WIZARD.CARRIER.COUNTRY_FINANCIAL
          ) {
            is_saved_forlater = 1;
          } else if (wizard.type_of_call
            //wizard.status == RENEWAL 
            && wizard.is_saved_for_later == 0
          ) {
            is_saved_forlater = 0;
          } else if (
            !wizard.type_of_call // NOSONAR
            // wizard.status == RENEWAL 
            &&
            wizard.is_saved_for_later == 1) { // NOSONAR
            is_saved_forlater = 1; // NOSONAR
          }
        }

        const policies = [];
        for (var i = 0; i < wizard.policies.length; i++) {
          if (wizard.policies[i].sold === "") {
            wizard.policies[i].sold = null;
          }
          policies.push({
            policy_sold: wizard.policies[i].sold,
            policy_type: wizard.policies[i].type
          });
        }
        const totalPnCItems =
          wizard.cross_sell_policies_uncovered +
          wizard.primary_vehicles_num +
          (wizard.home_toggle === "1" || wizard.home_toggle === "2" ? 1 : 0);

        const data = this.createData(wizard, policies, totalPnCItems);

        this.debounce(this.saveBFileRAC, 300)(wizard, data);
        // }
      }
    }
  };

  handleAutoFilledSelected = async (address) => {
    if (!this.props.isExternalBFile) {
      const { wizard } = this.state;
      const phoneInputValue = wizard.phone && wizard.phone.replace(/\D/g, '');
      if (wizard.first_name && wizard.last_name && wizard.phone && phoneInputValue.length == 10) {

        address.agency_id = wizard.agency_id;
        address.user_id = wizard.user_id;
        //address.is_saved_for_later = 1;
        if (wizard.completed) {
          address.is_saved_for_later = 0
        }
        else {
          if (
            //wizard.status == NEW_BFILE || wizard.carrier === WIZARD.CARRIER.COUNTRY_FINANCIAL
            !wizard.type_of_call
          ) {
            address.is_saved_for_later = 1;
          } else if (
            wizard.type_of_call
            //wizard.status == RENEWAL 
            &&
            wizard.is_saved_for_later == 0
          ) {
            address.is_saved_for_later = 0;
          } else if (
            !wizard.type_of_call // NOSONAR
            //wizard.status == RENEWAL
            &&
            wizard.is_saved_for_later == 1) { // NOSONAR
            address.is_saved_for_later = 1; // NOSONAR
          }
        }
        this.updateLoadingState(true);
        this.debounce(this.saveBFileRAC, 300)(wizard, address);
      }
    }
  }


  updatePolicies = () => {
    const { wizard } = this.state;

    let secondary_vehicles = [];
    if (
      wizard.secondary_vehicles !== null &&
      wizard.secondary_vehicles !== ""
    ) {
      secondary_vehicles = JSON.parse(wizard.secondary_vehicles);
    }

    let secondary_home_type = [];
    if (
      wizard.secondary_home_type !== null &&
      wizard.secondary_home_type !== ""
    ) {
      secondary_home_type = JSON.parse(wizard.secondary_home_type);
    }

    const policies = [];
    for (let i = 0; i < wizard.policies.length; i++) {
      if (secondary_vehicles.indexOf(wizard.policies[i].type) >= 0) {
        policies.push(wizard.policies[i]);
      }
      if (secondary_home_type.indexOf(wizard.policies[i].type) >= 0) {
        policies.push(wizard.policies[i]);
      }
      if (
        wizard.policies[i].type === "Umbrella" ||
        wizard.policies[i].type === "Rent"
      ) {
        policies.push(wizard.policies[i]);
      }
    }

    for (let i = 0; i < secondary_vehicles.length; i++) {
      let index = wizard.policies.findIndex(
        (item) => item.type === secondary_vehicles[i]
      );
      if (index < 0) {
        policies.push({
          type: secondary_vehicles[i],
          sold: "",
          policy: "auto"
        });
      }
    }

    for (let i = 0; i < secondary_home_type.length; i++) {
      let index = wizard.policies.findIndex(
        (item) => item.type === secondary_home_type[i]
      );
      if (index < 0) {
        policies.push({
          type: secondary_home_type[i],
          sold: "",
          policy: "home"
        });
      }
    }

    // if (wizard.home_toggle === "2") {
    //   let index = policies.findIndex((item) => item.type === "Rent");
    //   if (index < 0) {
    //     policies.push({
    //       type: "Rent",
    //       sold: "",
    //       policy: "home",
    //     });
    //   }
    // }

    {
      /** commenting below code for handling "Umbrella" */
    }
    // if (wizard.rac_calculator >= 250000) {
    //   let index = policies.findIndex((item) => item.type === "Umbrella");
    //   if (index < 0) {
    //     policies.push({
    //       type: "Umbrella",
    //       sold: "",
    //       policy: "",
    //     });
    //   }
    // } else {
    //   let index = policies.findIndex((item) => item.type === "Umbrella");
    //   if (index >= 0) {
    //     policies.splice(index, 1);
    //   }
    // }

    {
      /** Adding below code for handling "Umbrella" */
    }
    if (wizard.rac_calculator < 250000) {
      let index = policies.findIndex((item) => item.type === "Umbrella");
      if (index >= 0) {
        policies.splice(index, 1);
      }
    }

    wizard.policies = policies;

    let uncovered = 0;
    let sold = 0;
    let quoted = 0;
    let umbrella_sold = 0;
    let umbrella_uncovered = 0;
    let umbrella_quoted = 0;
    for (let i = 0; i < wizard.policies.length; i++) {
      if (wizard.policies[i].sold !== "1") {
        uncovered++;
      }
      if (wizard.policies[i].sold === "1") {
        sold++;
      }
      if (wizard.policies[i].quoted === "1") {
        quoted++;
      }
      if (wizard.policies[i].type === "Umbrella") {
        // wizard.policy_umbrella_total = 1;
        if (wizard.policies[i].sold === "1") {
          umbrella_sold++;
        }
        if (wizard.policies[i].sold === "0") {
          umbrella_uncovered++;
        }
        if (wizard.policies[i].sold === "2") {
          umbrella_quoted++;
        }
      }
    }

    wizard.cross_sell_policies_uncovered = uncovered;
    wizard.cross_sell_opportunities_quoted = quoted;
    wizard.cross_sell_opportunities_sold = sold;

    wizard.umbrella_policy_sold = umbrella_sold;
    wizard.umbrella_policy_uncovered = umbrella_uncovered;
    wizard.umbrella_policy_quoted = umbrella_quoted;


    this.setState({ wizard }, () => {
      this.saveWizard();
    });
  };

  smoothscroll() {
    // alert(1);
    // (function scroll() {
    //   var currentScroll =
    //     window.document.documentElement.scrollTop ||
    //     window.document.body.scrollTop;
    //   // alert(currentScroll);
    //   // if (currentScroll > 0) {
    //   //   window.requestAnimationFrame(scroll);
    //   //   window.scrollTo(0, currentScroll - currentScroll / 5);
    //   // }
    //   // window.requestAnimationFrame(scroll);
    //   window.scrollTo(0, 10);
    //   // window.scrollTo({
    //   //   top: 0,
    //   //   behavior: "smooth",
    //   // });
    // })();
    // window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    // window.scrollTo(0, 10);
    // window.scrollTo({
    //   top: 0,
    //   behavior: "smooth",
    // });
    const root = document.getElementById("root");
    root.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }


  prevStep = () => {
    const { wizard } = this.state;
    this.updateField("gotoStepIndex", wizard.stepIndex - 1, wizard.stepIndex);
    // this.smoothscroll();
    setTimeout(() => this.smoothscroll(), 50);
  };

  checkIFRequiredFieldsFilled() {
    let invalid = false;
    const wizard = JSON.parse(localStorage.getItem('wizard') || '{}');
    const { first_name, last_name, phone } = wizard;
    if (!first_name || !last_name || !phone) {
      invalid = true;
    }
    return invalid;
  }

  submitStep = (param) => {
    const { wizard } = this.state;
    if (typeof (param) == 'string' &&
      param == 'finalSubmitExternalBFile' && this.props.isExternalBFile) {
      if (!this.checkIFRequiredFieldsFilled()) {
        const data = this.finalSubmitExternalBFile();
        // console.log(JSON.stringify(data))
        this.saveExternalBFileRac(wizard, data);
      } else {
        message.error(PLEASE_FILL_ALL_REQUIRED_FIELD);
      }
    } else {
      const validation = Validation(wizard);
      this.updateField("stepIndex", wizard.stepIndex + 1, wizard.stepIndex);
      setTimeout(() => this.smoothscroll(), 50);
    }
  };



  finalSubmitExternalBFile() {
    const { wizard } = this.state;

    // External B Files can be submitted without rendering Step 6, so calculate
    // the same umbrella recommendation here before createData builds the payload.
    wizard.umbrella_limit = calculateUmbrellaLimitFromRac(
      wizard.rac_calculator
    );

    const policies = [];
    for (var i = 0; i < wizard.policies.length; i++) {
      if (wizard.policies[i].sold === "") {
        wizard.policies[i].sold = null;
      }
      policies.push({
        policy_sold: wizard.policies[i].sold,
        policy_type: wizard.policies[i].type
      });
    }
    const totalPnCItems =
      wizard.cross_sell_policies_uncovered +
      wizard.primary_vehicles_num +
      (wizard.home_toggle === "1" || wizard.home_toggle === "2" ? 1 : 0);

    let data = this.createData(wizard, policies, totalPnCItems);
    let bfile_wizard_data = wizard;
    // let bfile_wizard_data = JSON.parse(localStorage.getItem('wizard'));
    data = {
      ...data,
      // nullify bad_phone_number
      bad_phone_number_status: (bfile_wizard_data && bfile_wizard_data.id) ? bfile_wizard_data.bad_phone_number_status : 0,

      //reuploaded date
      reuploaded_on: (bfile_wizard_data && bfile_wizard_data.id) ? bfile_wizard_data.reuploaded_on :
        moment(new Date()).format("YYYY-MM-DD"),

      //for reset the file from non-responsive 
      non_responsive: (bfile_wizard_data && bfile_wizard_data.id) ? bfile_wizard_data.non_responsive : 0,

      //reset claimed calls
      vo_claim_date: (bfile_wizard_data && bfile_wizard_data.id) ? bfile_wizard_data.vo_claim_date : null,

      //appointments nullified when sent for follow_up
      von_appointment_date: (bfile_wizard_data && bfile_wizard_data.id) ? bfile_wizard_data.von_appointment_date : null,
      rs_appointment_date: (bfile_wizard_data && bfile_wizard_data.id) ? bfile_wizard_data.rs_appointment_date : null,

      //no reschedule nullified
      reschedule_appointment_vo: (bfile_wizard_data && bfile_wizard_data.id) ? bfile_wizard_data.reschedule_appointment_vo : 0,
      vob_attempted: (bfile_wizard_data && bfile_wizard_data.id) ? bfile_wizard_data.vob_attempted : null,
      vob_completed: (bfile_wizard_data && bfile_wizard_data.id) ? bfile_wizard_data.vob_completed : null,

      rs_action: bfile_wizard_data.id ? bfile_wizard_data.rs_action : null,
      rs_consecutive: bfile_wizard_data.id ? bfile_wizard_data.rs_consecutive : null,
      fs_consecutive: bfile_wizard_data.id ? bfile_wizard_data.fs_consecutive : null,

      //added new keys for fs
      onboarding_id: bfile_wizard_data.id ? bfile_wizard_data.onboarding_id : null,
      onboarding_user: bfile_wizard_data.id ? bfile_wizard_data.onboarding_user : null,
      vob_archived: bfile_wizard_data.id ? bfile_wizard_data.vob_archived : null,


      rs_effective_date: (bfile_wizard_data && bfile_wizard_data.id) ? bfile_wizard_data.rs_effective_date
        : moment().format("YYYY-MM-DD"),

      vonboard: bfile_wizard_data.vonboard || bfile_wizard_data.type_of_call &&
        ['followup', 'prospect'].includes(bfile_wizard_data.type_of_call.split('-').join().toLowerCase()) ? 1 : 0,
      review: bfile_wizard_data.review || bfile_wizard_data.type_of_call && ['Review'].includes(bfile_wizard_data.type_of_call.split('-').join().toLowerCase()) ? 1 : 0,
    }




    let bfile_sub = [];

    if (!bfile_wizard_data.id) {
      bfile_sub = bfile_wizard_data.type_of_call != REVIEW ? [
        {
          fs_effective_date: moment().format("YYYY-MM-DD"),
          fs_expiration_date: moment().add(30, "days").format("YYYY-MM-DD"),
          id: bfile_wizard_data.bfile_sub && bfile_wizard_data.bfile_sub.length > 0 ? bfile_wizard_data.bfile_sub[0].id : null,
        }
      ] : [
        {
          id: bfile_wizard_data.bfile_sub && bfile_wizard_data.bfile_sub.length > 0 ? bfile_wizard_data.bfile_sub[0].id : null,
          rs_review_month: Number(moment().format("M"))
        }
      ];

      if (bfile_wizard_data.type_of_call == REVIEW) {
        data.expiration_date = moment().endOf('month').format("YYYY-MM-DD");
      }

      if (bfile_sub.length > 0 && bfile_sub[0].id) {
        data.bfile_sub = bfile_sub;
      } else {
        delete data.bfile_sub;
      }

    } else if (bfile_wizard_data.id && bfile_wizard_data.bfile_sub && bfile_wizard_data.bfile_sub.length > 0 && bfile_wizard_data.bfile_sub[0].id) {
      // UPDATE
      bfile_sub = [{ ...data.bfile_sub[0] }];

      data.bfile_sub = bfile_sub;
    } else {
      data.bfile_sub = []
    }

    return data;
  }


  // saveTest = (callback) => {
  //   const { wizard, user } = this.state;
  //   F.testSave(wizard);
  // };
  save = (callback) => {
    message.destroy();
    this.updateLoadingState(true)
    const thatProps = this.props;
    const { wizard, user } = this.state;

    // alert(wizard.cross_sell_policies_uncovered);
    // return null;

    if (wizard.email && wizard.email !== "") {
      if (!F.validateEmail(wizard.email)) {
        message.error(EMAIL_ADDRESS_IS_INVALID);
        this.updateLoadingState(false);
        // setTimeout(() => {
        //   callback();
        // }, 0);
        return;
      }
    }

    if (wizard.children === "") wizard.children = null;

    // wizard.life_opportunities = 0;
    // if (typeof wizard.children === "number" && wizard.children > 0) {
    //   wizard.life_opportunities++;
    // }

    wizard.rollover_opportunities = 0;

    if (
      wizard.acknowledge &&
      wizard.acknowledge_by !== null &&
      wizard.acknowledge_by !== ""
    ) {
      wizard.acknowledge_by = user.id;
    }

    if (wizard.birthday !== "" && wizard.birthday !== null) {
      const customer_age = F.getAge(new Date(wizard.birthday));

      {
        /** Adding new code for protection mortage policy */
      }
      // let home_mortgage_protection_policy = [];
      // if (
      //   wizard.home_mortgage_protection_policy != null &&
      //   wizard.home_mortgage_protection_policy !== ""
      // ) {
      //   home_mortgage_protection_policy = JSON.parse(
      //     wizard.home_mortgage_protection_policy
      //   );

      //   if (
      //     (home_mortgage_protection_policy.includes("Term") ||
      //       home_mortgage_protection_policy.includes("Universal/Whole-Life")) &&
      //     customer_age >= 20 &&
      //     customer_age <= 75
      //   ) {
      //     wizard.life_opportunities++;
      //   }
      // }

      if (
        wizard.asset_401k_accounts !== null &&
        wizard.asset_401k_accounts !== ""
      ) {
        const asset_401k_accounts = JSON.parse(wizard.asset_401k_accounts);
        const asset_401k = asset_401k_accounts.indexOf("401k");
        const asset_403b = asset_401k_accounts.indexOf("403b");
        const asset_457 = asset_401k_accounts.indexOf("457");

        if (
          asset_401k >= 0 &&
          asset_403b >= 0 &&
          asset_457 >= 0 &&
          customer_age >= 20 &&
          customer_age <= 75
        ) {
          wizard.rollover_opportunities++;
        }
      }
    }
    if (wizard.spouse_birthday !== "" && wizard.spouse_birthday !== null) {
      const customer_spouse_age = F.getAge(new Date(wizard.spouse_birthday));

      if (
        wizard.asset_401k_accounts_spouse !== null &&
        wizard.asset_401k_accounts_spouse !== ""
      ) {
        const asset_401k_accounts_spouse = JSON.parse(
          wizard.asset_401k_accounts_spouse
        );
        const asset_401k = asset_401k_accounts_spouse.indexOf("401k");
        const asset_403b = asset_401k_accounts_spouse.indexOf("403b");
        const asset_457 = asset_401k_accounts_spouse.indexOf("457");

        if (
          asset_401k >= 0 &&
          asset_403b >= 0 &&
          asset_457 >= 0 &&
          customer_spouse_age >= 20 &&
          customer_spouse_age <= 75
        ) {
          wizard.rollover_opportunities++;
        }
      }
    }

    // calculate rollover dollars created
    wizard.rollover_dollars_created = "";

    if (wizard.acknowledge !== null && wizard.acknowledge_by !== "") {
      wizard.acknowledge_by = user.id;
    }

    const policies = [];
    for (var i = 0; i < wizard.policies.length; i++) {
      if (wizard.policies[i].sold === "") {
        wizard.policies[i].sold = null;
      }
      policies.push({
        policy_sold: wizard.policies[i].sold,
        policy_type: wizard.policies[i].type
      });
    }

    // const totalPnCItems =
    //   wizard.cross_sell_policies_uncovered +
    //   (wizard.primary_vehicles_num - 1) +
    //   (wizard.primary_vehicles_toggle === "1" ||
    //   wizard.primary_vehicles_toggle === "2"
    //     ? 1
    //     : 0) +
    //   (wizard.home_toggle === "1" || wizard.home_toggle === "2" ? 1 : 0);

    const totalPnCItems =
      wizard.cross_sell_policies_uncovered +
      wizard.primary_vehicles_num +
      (wizard.home_toggle === "1" || wizard.home_toggle === "2" ? 1 : 0);

    // F.log("PNC: First Option ==>>", wizard.primary_vehicles_num);
    // F.log("PNC: Second Option ==>>", wizard.cross_sell_policies_uncovered);
    // F.log("PNC: Home Toggle ==>>", wizard.home_toggle);
    // F.log("PNC: totalPnCItems==>>", totalPnCItems);
    const data = {
      agency_id: wizard.agency_id,
      acknowledge_by: wizard.acknowledge_by,
      first_name: wizard.first_name,
      address: wizard.address,
      address_cont: wizard.address_cont,
      business_name: wizard.business_name,
      business_name_spouse: wizard.business_name_spouse,

      business_owner_toggle: wizard.business_owner_toggle,
      business_owner_spouse_toggle: wizard.business_owner_spouse_toggle,

      business_type_spouse: wizard.business_type_spouse,
      business_type_other_spouse: wizard.business_type_other_spouse,

      business_type: wizard.business_type,
      business_type_other: wizard.business_type_other, // new add

      employed_toggle: wizard.employed_toggle, // new add
      employed_toggle_spouse: wizard.employed_toggle_spouse,
      employer_name: wizard.employer_name, // new add
      employer_name_spouse: wizard.employer_name_spouse,
      employer_years: wizard.employer_years, // new add
      employer_years_spouse: wizard.employer_years_spouse,
      employed_anual_income: wizard.employed_anual_income,
      employed_anual_income_spouse: wizard.employed_anual_income_spouse,

      city: wizard.city,
      email: wizard.email,
      employed_retired_disabled: wizard.employed_retired_disabled,
      employed_retired_disabled_spouse: wizard.employed_retired_disabled_spouse,
      employer_retire_from: wizard.employer_retire_from,
      employer_retire_from_spouse: wizard.employer_retire_from_spouse,
      home_market_value: wizard.home_market_value,
      home_mortgage: wizard.home_mortgage,
      home_mortgage_protection_toggle: wizard.home_mortgage_protection_toggle,
      home_mortgage_protection_benefit: wizard.home_mortgage_protection_benefit,
      home_mortgage_toggle: wizard.home_mortgage_toggle,
      home_mortgage_protection_policy: wizard.home_mortgage_protection_policy,
      home_toggle: wizard.home_toggle,
      insurance_score: wizard.insurance_score,
      last_name: wizard.last_name,
      spouse_last_name: wizard.spouse_last_name,
      // phone: wizard.phone,
      phone: F.removeFormatterFromPhoneNumber(wizard.phone),
      retirement_plan: wizard.retirement_plan,
      retirement_plan_value: wizard.retirement_plan_value,
      retirement_plan_spouse: wizard.retirement_plan_spouse,
      retirement_plan_value_spouse: wizard.retirement_plan_value_spouse,
      secondary_home_market_value: wizard.secondary_home_market_value,
      secondary_home_mortgage: wizard.secondary_home_mortgage,
      secondary_mortgage_protection_benefit:
        wizard.secondary_mortgage_protection_benefit,
      secondary_mortgage_protection_policy:
        wizard.secondary_mortgage_protection_policy,
      secondary_mortgage_protection_toggle:
        wizard.secondary_mortgage_protection_toggle,
      secondary_home_mortgage_toggle: wizard.secondary_home_mortgage_toggle,
      secondary_home_toggle: wizard.secondary_home_toggle,
      secondary_home_type: wizard.secondary_home_type,
      personal_property_toggle: wizard.personal_property_toggle,
      personal_property_value: wizard.personal_property_value,
      primary_vehicles_toggle: wizard.primary_vehicles_toggle,
      primary_vehicles_num: wizard.primary_vehicles_num,
      secondary_vehicles_toggle: wizard.secondary_vehicles_toggle,
      secondary_vehicles_value: wizard.secondary_vehicles_value,
      secondary_vehicles: wizard.secondary_vehicles,
      spouse_first_name: wizard.spouse_first_name,
      spouse_toggle: wizard.spouse_toggle,
      type_of_call: wizard.type_of_call,
      sub_type_of_call: wizard.sub_type_of_call,
      asset_total_value: wizard.asset_total_value,
      asset_total_value_spouse: wizard.asset_total_value_spouse,
      zipcode: wizard.zipcode,
      state: wizard.state,
      asset_preservation_toggle: wizard.asset_preservation_toggle,
      asset_preservation_value: wizard.asset_preservation_value,
      asset_preservation_toggle_spouse: wizard.asset_preservation_toggle_spouse,
      asset_preservation_value_spouse: wizard.asset_preservation_value_spouse,
      life_opportunities: wizard.life_opportunities,
      no_policies_sold: wizard.no_policies_sold,
      // policy_umbrella_total: wizard.policy_umbrella_total,
      policy_umbrella_total: wizard.umbrella_limit !== "" ? 1 : 0,
      //rollover_dollars_created: wizard.rollover_dollars_created,
      rollover_opportunities: wizard.rollover_opportunities,
      status: wizard.status,
      quote_auto_toggle: wizard.quote_auto_toggle,
      auto_sold_toggle: wizard.auto_sold_toggle,
      quote_home_toggle: wizard.quote_home_toggle,
      employees_count: wizard.employees_count,
      employees_count_spouse: wizard.employees_count_spouse,
      home_sold_toggle: wizard.home_sold_toggle,
      cross_sell_policies_uncovered: totalPnCItems < 0 ? 0 : totalPnCItems,
      cross_sell_opportunities_quoted: wizard.cross_sell_opportunities_quoted,
      cross_sell_opportunities_sold: wizard.cross_sell_opportunities_sold,
      umbrella_policy_quoted: wizard.umbrella_policy_quoted,
      umbrella_policy_sold: wizard.umbrella_policy_sold,
      umbrella_policy_uncovered: wizard.umbrella_policy_uncovered,
      umbrella_limit: wizard.umbrella_limit,
      attempts: wizard.attempts,
      action: wizard.action,
      call_type: wizard.call_type,
      callback_time: wizard.callback_time,
      vip: wizard.vip,
      children: wizard.children,
      need_attention: wizard.need_attention,
      birthday: wizard.birthday && wizard.birthday != null && wizard.birthday != undefined ? wizard.birthday.split(" ").join("") : "",
      spouse_birthday: wizard.spouse_birthday ? wizard.spouse_birthday.split(" ").join("") : "",
      phone2: wizard.phone2,
      auto_policy_sold_current_liability_limit:
        wizard.auto_policy_sold_current_liability_limit,
      auto_policy_sold_bfile_limit: wizard.auto_policy_sold_bfile_limit,
      auto_policy_sold_liability_limit_sold:
        wizard.auto_policy_sold_liability_limit_sold,
      auto_policy_sold_items_sold: wizard.auto_policy_sold_items_sold,
      auto_policy_sold_policy_premium: wizard.auto_policy_sold_policy_premium,
      auto_policy_sold_term: wizard.auto_policy_sold_term,
      auto_policy_not_sold_current_carrier:
        wizard.auto_policy_not_sold_current_carrier,
      auto_policy_not_sold_current_liability_limit:
        wizard.auto_policy_not_sold_current_liability_limit,
      auto_policy_not_sold_expiration_date:
        wizard.auto_policy_not_sold_expiration_date,
      home_policy_sold_liability_limit: wizard.home_policy_sold_liability_limit,
      home_policy_sold_bfile_limit: wizard.home_policy_sold_bfile_limit,
      home_policy_sold_liability_limit_sold:
        wizard.home_policy_sold_liability_limit_sold,
      home_policy_sold_items_sold: wizard.home_policy_sold_items_sold,
      home_policy_sold_policy_premium: wizard.home_policy_sold_policy_premium,
      home_policy_sold_term: wizard.home_policy_sold_term,
      home_policy_not_sold_current_carrier:
        wizard.home_policy_not_sold_current_carrier,
      home_policy_not_sold_current_liability_limit:
        wizard.home_policy_not_sold_current_liability_limit,
      home_policy_not_sold_expiration_date:
        wizard.home_policy_not_sold_expiration_date,
      auto_policy_sold_effective_date: wizard.auto_policy_sold_effective_date,
      home_policy_sold_effective_date: wizard.home_policy_sold_effective_date,
      is_lead: wizard.is_lead,
      is_saved_for_later: wizard.is_saved_for_later,
      is_requote: wizard.is_requote,
      is_renewal: wizard.is_renewal,
      is_onboarded: wizard.is_onboarded,
      nosalearchive_expiration_date: wizard.nosalearchive_expiration_date,
      facebook: wizard.facebook,
      twitter: wizard.twitter,
      linkedin: wizard.linkedin,
      profile_photo: wizard.profile_photo,
      archive: wizard.archive,
      user_id: wizard.user_id,
      parent_id: wizard.parent_id,
      bfile_folow_up_completed: null,
      bfile_review_completed: 0,
      //vonboard: wizard.vonboard,
      financial_id: wizard.financial_id,
      onboarding_id: wizard.onboarding_id,
      asset_401k_accounts: wizard.asset_401k_accounts,
      asset_401k_accounts_spouse: wizard.asset_401k_accounts_spouse,
      asset_accounts: wizard.asset_accounts,
      asset_accounts_spouse: wizard.asset_accounts_spouse,
      asset_account_spouse: wizard.aseet_account_spouse,
      personal_property_type: wizard.personal_property_type,
      policies: policies,
      liability_calculator_value: wizard.rac_calculator,
      onboarder_id: wizard.onboarder_id,
      vo_sent_date: wizard.vo_sent_date,
      mortgage_review: wizard.mortgage_review,
      mortgage_purchase_home: wizard.mortgage_purchase_home,
      had_mortgage_review: wizard.had_mortgage_review,
      no_follow_up: wizard.no_follow_up,

      // new add
      asset_401k_accounts_toggle: wizard.asset_401k_accounts_toggle,
      asset_401k_accounts_toggle_spouse:
        wizard.asset_401k_accounts_toggle_spouse,
      asset_401k_value: wizard.asset_401k_value,
      home_mortgage_protection_benefit_spouse: wizard.home_mortgage_protection_benefit_spouse,
      home_mortgage_protection_policy_spouse: wizard.home_mortgage_protection_policy_spouse,

      // new add for primary home
      step_insurance_question: wizard.step_insurance_question,
      insurance_set: wizard.insurance_set,
      zillow_address: wizard.zillow_address,
      zillow_estimated_value: wizard.zillow_estimated_value,
      secondary_zillow_address: wizard.secondary_zillow_address,
      secondary_zillow_estimated_value: wizard.secondary_zillow_estimated_value,

      //for reset the file from non-responsive 
      non_responsive: 0,

      //for marking bfile completed
      completed: wizard.coverage ? 1 : 0,

      //reset claimed calls
      vo_claim_date: null,

      //appointments nullified when sent for follow_up
      von_appointment_date: null,
      rs_appointment_date: null,

      //reschedule nullified
      reschedule_appointment_vo: 0,
      vob_attempted: null,
      vob_completed: null,
      rs_action: null,

      //reuploaded date
      reuploaded_on: moment(new Date()).format("YYYY-MM-DD"),

      // vonboard: ['followup', 'prospect'].includes(wizard.type_of_call.split('-').join().toLowerCase()) ? 1 : 0,
      // review: ['followup', 'prospect'].includes(wizard.type_of_call.split('-').join().toLowerCase()) ? 0 : 1,
      vonboard: wizard.vonboard || wizard.type_of_call && ['followup', 'prospect'].includes(wizard.type_of_call.split('-').join().toLowerCase()) ? 1 : 0,
      review: wizard.review || wizard.type_of_call && ['Review'].includes(wizard.type_of_call.split('-').join().toLowerCase()) ? 1 : 0,
      ...(this.state.wizard.isSentBfile ? {
        // rs_effective_date: wizard.expiration_date,
        // expiration_date: wizard.expiration_date ? moment(wizard.expiration_date).add(30, "days").format('YYYY-MM-DD') : null,
      } : {}),
      ...(wizard.vob_archived === 1 ? { vob_archived: null, onboarding_user: null, onboarding_id: null } : {}),
    };

    // schedule appointment nullification
    // if (wizard.type_of_call_old !== wizard.type_of_call) {
    //   data = {
    //     ...data,
    //     von_appointment_date: null,
    //   }
    // }


    //api call to nullify distance and timezone
    if (wizard.profile_address_updated && wizard.id !== "") {
      axios.put('/api/b_file/' + wizard.id, {
        "customer_timezone": null,
        "customer_distance": null
      })
    }

    let ajax = null;
    if (wizard.id !== "") {
      ajax = axios.put("/api/b_file/" + wizard.id, data);
    } else {
      ajax = axios.post("/api/b_file", data);
    }
    ajax.then((res) => {
      const bfile = res.data;

      // trigger point for upload history
      axios.post("/api/upload_history_details",
        {
          bfile_id: bfile.id,
          bfile_user_id: this.state.user.id,
          creator_user_id: this.state.user.id,
          modifier_user_id: this.state.user.id,
          agency_id: bfile.agency_id,
          type_of_call: bfile.type_of_call,
          sub_type_of_call: bfile.sub_type_of_call,
          first_name: bfile.first_name,
          last_name: bfile.last_name,
          phone: bfile.phone,
        }
      );

      axios.put(UPDATE_RAC_DATE(wizard.id), {
        fs_effective_date: moment(wizard.expiration_date).format('YYYY-MM-DD')
      });

      if (wizard.id === "") {
        this.updateField("id", bfile.id);
      }

      if (wizard.acknowledge === "1") {
        axios.post("/api/bfile_notes", {
          bfile_id: bfile.id,
          note:
            "Confirmed liability conversation acknowledged by customer: " +
            wizard.first_name +
            " " +
            wizard.last_name,
          is_acknowledgement: 1,
          user_id: this.props.auth.user.id,
          action: "Confirmed liability conversation acknowledged",
          type_of_call: wizard.type_of_call,
          sub_type_of_call: wizard.sub_type_of_call,
        });
      }

      if (wizard.acknowledge === "0") {
        axios.post("/api/bfile_notes", {
          bfile_id: bfile.id,
          note:
            "Confirmed liability conversation not acknowledged by customer: " +
            wizard.first_name +
            " " +
            wizard.last_name,
          is_acknowledgement: 0,
          user_id: this.props.auth.user.id,
          action: "Confirmed liability conversation not acknowledged",
          type_of_call: wizard.type_of_call,
          sub_type_of_call: wizard.sub_type_of_call,
        });
      }

      if (wizard.mortgage_review_last !== wizard.mortgage_review) {
        let note = "";
        if (wizard.mortgage_review === 1) {
          note =
            moment(new Date()).format("MM/DD/YYYY") +
            " - Customer interested in a mortgage review.";
          axios
            .post("/api/send_mortgage_email", {
              bfile_id: bfile.id
            })
            .then((res) => { });
        }
        if (wizard.mortgage_review === 0) {
          note =
            moment(new Date()).format("MM/DD/YYYY") +
            " - Customer denied a mortgage review.";
        }
        if (note !== "") {
          axios.post("/api/bfile_notes", {
            bfile_id: bfile.id,
            note: note,
            user_id: this.props.auth.user.id,
            action: "Customer denied a mortgage review",
            type_of_call: wizard.type_of_call,
            sub_type_of_call: wizard.sub_type_of_call,
          });
        }
      }

      if (wizard.notes !== null && wizard.notes !== "") {
        axios.post("/api/bfile_notes", {
          bfile_id: bfile.id,
          note: wizard.notes,
          user_id: this.props.auth.user.id,
          action: "Wizard Note",
          type_of_call: wizard.type_of_call,
          sub_type_of_call: wizard.sub_type_of_call,
        });
      }

      if (typeof callback !== "undefined") {
        callback(bfile);
      }
      // message.success("Bfile has been created");
      // this.props.history.push("/dashboard");

      var printData = document.querySelector(".user-data");

      if (printData) {
        printData.style.display = "block";
        printData.style.position = "absolute";
        printData.style.padding = "25px";


        // html2canvas(printData).then(function(canvas) {
        //   var ctx = canvas.getContext("2d");
        //   var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        //   var data = imageData.data;

        //   for (var i = 0; i < data.length; i += 4) {
        //     var grayscale =
        //       data[i] * 0.299 + data[i + 1] * 0.587 + data[i + 2] * 0.114;
        //     data[i] = grayscale;
        //     data[i + 1] = grayscale;
        //     data[i + 2] = grayscale;
        //   }

        //   ctx.putImageData(imageData, 0, 0);

        //   const base64Image = canvas.toDataURL("img/png");
        //   const doc = new jsPDF("p", "mm", "a4");
        //   const componentWidth = doc.internal.pageSize.getWidth();
        //   doc.addImage(base64Image, "PNG", 0, 0, componentWidth, 0);
        //   const pdfBase64 = doc.output("datauristring");

        //   if (pdfBase64 && bfile && bfile.id) {
        //     axios
        //       .post("/api/pdfuploader", {
        //         Bfile_data: pdfBase64,
        //         phone: bfile.phone,
        //         bfile_id: bfile.id,
        //       })
        //       .then((e) => {
        //         message.success("Bfile pdf has been Saved");
        //       })
        //       .catch((e) => {
        //         message.error(F.translate("Unable to Save Pdf."));
        //       });
        //   }




        // });
      }
      this.updateLoadingState(true);
      if (bfile && bfile.id && bfile.is_saved_for_later == 1) {
        message.success(PROFILE_HAS_BEEN_UPDATED_AND_SAVED_FOR_LATER);
        thatProps.history.push({ pathname: user.id === 2 ? '/bfiles' : "/dashboard", state: { ...thatProps.location.state } });
      } else if (bfile && bfile.id && bfile.is_saved_for_later == 0) {
        message.success(BFILE_HAS_BEEN_UPDATED);
        thatProps.history.push({ pathname: user.id === 2 ? '/bfiles' : "/dashboard", state: { ...thatProps.location.state } });
      }
      this.updateLoadingState(false);
    });
  };

  updateLoadingState = (loading) => {
    this.setState({ loading });
  };


  showNotification = () => {
    notification.warning({
      message: 'Please recheck your number!',
      description: `This phone number already exists in our system. 
      If it is yours, please continue filling the information and your profile will be updated accordingly. 
      If not, please change the number and proceed.`,
      duration: 15,
    });
  };



  checkExistingCustomerExternalBFile = async (wizard, phoneNumberFormatterRemoved) => {
    this.updateLoadingState(true);
    try {
      const response = await axios.post(EXTERNAL_RAC_EXISTING_CUSTOMER_CHECK, {
        phone: phoneNumberFormatterRemoved,
        skip_child: true,
        agency_id: wizard.agency_id
      });


      return response;

    } catch (error) {
      console.error("API call failed:", error);
      return {
        success: false,
        error: error
      };
    } finally {
      this.updateLoadingState(false);
    }
  }



  checkDuplicateCustomer = async () => {
    const { wizard } = this.state;

    // check valid phone number
    if (F.validatePhoneRegix(wizard.phone)) {
      // remove Formatter From Phone Number
      const phoneNumberFormatterRemoved = F.removeFormatterFromPhoneNumber(
        wizard.phone
      );

      // check customer exist for internal Intelligence Link
      if (!this.props.isExternalBFile) {
        const historyState = this.props.history.location;
        this.updateLoadingState(true);
        axios
          .post(`/api/check_customer_exist${historyState.state && historyState.state.user_type && historyState.state.user_type === 'BOBADMIN' && `?user_type=${historyState.state.user_type}` || ''}`, {
            phone: phoneNumberFormatterRemoved,
            skip_child: true, // only parent will consider
            agency_id: wizard.agency_id
          })
          .then((res) => {
            // found duplicate
            if (
              res.data.exist &&
              wizard.id !== res.data.bfile_id &&
              wizard.parent_id !== res.data.bfile_id
            ) {
              // set to `false` to not show `Sending B File Modal`
              DataHandler.setSendingBFileModalState(false);
              this.updateField("show_modal_customer_exist", true);
              this.updateField("modal_customer_bfile_id", res.data.bfile_id);
              this.updateLoadingState(false);
            } else {
              // set to `true` to show `Sending B File Modal`
              DataHandler.setSendingBFileModalState(true);
              // make `parent_id` reset to default
              this.updateField("show_modal_customer_exist", false);
              this.updateField("modal_customer_bfile_id", null);
              if (!this.props.isExternalBFile) {
                this.handleBlur("phone", wizard.phone);
              }
              this.updateLoadingState(false);
            }
          }, (error) => {
            this.updateLoadingState(false);
          });
      } else {
        //External B File Customer Exist

        const result = await this.checkExistingCustomerExternalBFile(wizard, phoneNumberFormatterRemoved);
        if (result && result.data && result.data.exist) {
          this.getBFileData(result.data.bfile_id);
          // const updatedWizard = {
          //   ...wizard,
          //   id: result.data.bfile_id,
          //   type_of_call: result.data.type_of_call,
          //   sub_type_of_call: result.data.sub_type_of_call,
          //   review: result.data.type_of_call === "Review" ? 1 : 0,
          //   bfile_sub: result.data.bfile_sub,
          // };

          // this.setState({ wizard: updatedWizard });
          this.showNotification();
        } else {
          const updatedWizard = {
            ...wizard,
            id: "",
            type_of_call: PROSPECT,
            sub_type_of_call: RE_QUOTE,
          };
          this.setState({ wizard: updatedWizard });
        }
      }
    }
  };

  render() {
    const { loading, wizard, user } = this.state;
    const { location } = this.props.history;
    let WizardStep = Step1;

    if (!loading && wizard.stepIndex === 0) {
      WizardStep = StepCall;
    }
    F.log("stepIndex ==> " + wizard.stepIndex);

    if (wizard.stepIndex === 1) WizardStep = Step1;
    if (wizard.stepIndex === 2) WizardStep = Step2;
    if (wizard.stepIndex === 3) WizardStep = Step2_1;
    if (wizard.stepIndex === 4) WizardStep = Step3;
    if (wizard.stepIndex === 5) WizardStep = Step3_1;
    if (wizard.stepIndex === 6) WizardStep = Step3_2;
    if (wizard.stepIndex === 7) WizardStep = Step3_3;
    if (wizard.stepIndex === 8) WizardStep = Step3_4;
    if (wizard.stepIndex === 9) WizardStep = Step4;
    if (wizard.stepIndex === 10) WizardStep = Step4_1;
    if (wizard.stepIndex === 11) WizardStep = Step5;
    if (wizard.stepIndex === 12) WizardStep = Step5_1;
    if (wizard.stepIndex === 13) {
      if (!this.props.isExternalBFile) {
        WizardStep = Step6;
      } else {
        WizardStep = ExternalBFileThanks;
      }
    }

    // if (wizard.stepIndex === 14) WizardStep = Step7;
    // if (wizard.stepIndex === 14) WizardStep = Step7_1;

    return (
      <div style={{ marginTop: "-25px" }}>
        <ScrollToTop>
          <WizardSteps {...this.props} wizard={wizard} save={this.save} user={this.state.user}
            updateField={this.updateField} handleBlur={this.handleBlur} handleAutoFilledSelected={this.handleAutoFilledSelected}
            checkDuplicateCustomer={this.checkDuplicateCustomer}
            updateRadioBtnToggle={this.updateRadioBtnToggle}
            complete={this.complete}
          />
          {wizard.stepIndex < 13 ? (
            <Row type="flex" gutter={16} className="steps">
              {/* <Col lg={{ span: 6, order: 0 }} span={24} xs={{ order: 1 }}>
              <Sidebar wizard={wizard} />
            </Col> */}
              <Col lg={{ span: 24, order: 0 }} span={24} xs={{ order: 0 }}>
                <Spin spinning={loading}>
                  <WizardStep
                    isExternalBFile={this.props.isExternalBFile}
                    agencyId={this.props.extAgencyId}
                    userId={this.props.extUserId}
                    wizard={wizard}
                    updateField={this.updateField}
                    handleBlur={this.handleBlur}
                    checkDuplicateCustomer={this.checkDuplicateCustomer}
                    handleAutoFilledSelected={this.handleAutoFilledSelected}
                    updateRadioBtnToggle={this.updateRadioBtnToggle}
                    submitStep={this.submitStep}
                    prevStep={this.prevStep}
                    save={this.save}
                    complete={this.complete}
                    user={this.state.user}
                    history={this.props.history}
                    is_calculator_only={this.state.is_calculator_only}
                    // bfile_type={this.props.location.search}
                    bfile_id={this.props.match.params.bfile_id}
                    updateLoadingState={this.updateLoadingState}
                    agency_owner_details={this.state.agency_owner_details}
                    isFromDirectUrl={this.props.isFromDirectUrl || (location.state && location.state.isFromDirectUrl && location.state.isFromDirectUrl) || false}
                  />
                </Spin>
              </Col>
            </Row>
          ) : (
            <Row type="flex" gutter={16}>
              <Col lg={{ span: 24, order: 0 }} span={24} xs={{ order: 0 }}>
                <Spin indicator={antIcon} spinning={loading}>
                  <WizardStep
                    isExternalBFile={this.props.isExternalBFile}
                    agencyId={this.props.extAgencyId}
                    userId={this.props.extUserId}
                    wizard={wizard}
                    updateField={this.updateField}
                    handleBlur={this.handleBlur}
                    checkDuplicateCustomer={this.checkDuplicateCustomer}
                    handleAutoFilledSelected={this.handleAutoFilledSelected}
                    updateRadioBtnToggle={this.updateRadioBtnToggle}
                    submitStep={this.submitStep}
                    prevStep={this.prevStep}
                    save={this.save}
                    user={this.state.user}
                    history={this.props.history}
                    is_calculator_only={this.state.is_calculator_only}
                    // bfile_type={this.props.location.search}
                    bfile_id={this.props.match.params.bfile_id}
                    agency_owner_details={this.state.agency_owner_details}
                    updateLoadingState={this.updateLoadingState}
                    isFromDirectUrl={this.props.isFromDirectUrl || (location.state && location.state.isFromDirectUrl) || false}
                  />
                </Spin>
              </Col>
            </Row>
          )}
          {this.state.change_ownership_modal ? (
            <ChangeOwnershipModal
              showModal={this.state.change_ownership_modal}
              hideModal={() => this.setState({ change_ownership_modal: false })}
              wizard={wizard}
              change={() => {
                this.updateField("user_id", user.id);
                this.setState({ change_ownership_modal: false });
              }}
            />
          ) : null}
        </ScrollToTop>
      </div>
    );
  }

}

export default Wizard;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/index_updated.js